(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liner-configurator"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('liner-configurator')) {
  customElements.define('liner-configurator', class extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      try { this.pricing = await import(this.dataset.pricingModule); }
      catch { this.querySelector('[data-calculation-error]').hidden = false; return; }
      this.step = 0;
      this.reached = 0;
      this.fields = [...this.querySelectorAll('[data-step]')];
      this.form = this.querySelector('form');
      this.contact = this.querySelector('[data-contact]');
      this.querySelector('[data-back]').addEventListener('click', () => this.show(this.step === 3 && this.checked('form')?.dataset.code !== 'rectangle' ? 1 : this.step - 1));
      this.querySelector('[data-next]').addEventListener('click', () => { if (this.valid(this.step)) this.show(this.step === 1 && this.checked('form')?.dataset.code !== 'rectangle' ? 3 : this.step + 1); });
      this.querySelectorAll('[data-jump]').forEach(b => b.addEventListener('click', () => this.show(Number(b.dataset.jump))));
      this.querySelector('[data-edit]').addEventListener('click', () => this.show(0));
      this.addEventListener('input', event => { if(['length','width','depth_label'].includes(event.target.dataset.key))this.querySelector('[data-standard-size]').value=''; if(event.target.dataset.key==='diagram_depth')this.field('depth_label').value=event.target.value; if(event.target.dataset.measure)this.measureError(event.target,''); this.update(); });
      this.addEventListener('change', () => this.update());
      this.querySelector('[data-buy]').addEventListener('click', () => this.buy());
      this.querySelector('[data-mobile-review]').addEventListener('click', () => { for(let i=0;i<4;i++){if(!this.valid(i)){this.show(i);this.valid(i);return;}}this.show(4); });
      this.form.addEventListener('submit', event => {
        if(this.variantId){event.preventDefault();this.buy();return;}
        for (let i = 0; i < 4; i++) {
          if (!this.valid(i)) { event.preventDefault(); this.show(i); this.valid(i); return; }
        }
        this.update();
      });
      this.form.noValidate = true;
      this.form.addEventListener('submit', event => {
        if (event.defaultPrevented) return;
        const invalid = [...this.contact.querySelectorAll('input,textarea')].find(el => !el.checkValidity());
        if (invalid) { event.preventDefault(); this.show(4); invalid.reportValidity(); }
      });
      this.querySelector('[data-copy]').addEventListener('click', async () => {
        try { await navigator.clipboard.writeText(this.querySelector('[data-config]').value); this.querySelector('[data-copy-status]').textContent = this.dataset.copied; }
        catch { this.querySelector('[data-copy-status]').textContent = this.dataset.copyFailed; }
      });
      this.querySelectorAll('[data-pdf]').forEach(b=>b.addEventListener('click',()=>{const data=JSON.parse(this.querySelector('[data-measure-pdfs]').textContent)[b.dataset.pdf];const bytes=Uint8Array.from(atob(data),c=>c.charCodeAt(0));const url=URL.createObjectURL(new Blob([bytes],{type:'application/pdf'}));const a=document.createElement('a');a.href=url;a.download=b.dataset.pdf==='corner'?'Matmall-horntrappa.pdf':'Matmall-helgaveltrappa.pdf';a.click();setTimeout(()=>URL.revokeObjectURL(url),10000);}));if(!this.field('depth_label').value)this.field('depth_label').value='150';this.priceRows=JSON.parse(this.querySelector('[data-factory-prices]').textContent);this.modelChoice='';this.models=JSON.parse(this.querySelector('[data-stair-catalog]').textContent);this.drawings=JSON.parse(this.querySelector('[data-stair-drawings]').textContent);this.labels={...JSON.parse(this.querySelector('[data-labels]').textContent),...JSON.parse(this.querySelector('[data-pricing-labels]').textContent)};this.querySelector('[data-standard-size]').addEventListener('change',e=>{const r=this.priceRows[Number(e.target.value)];if(e.target.value!==''&&r){this.field('length').value=r.length;this.field('width').value=r.width;this.field('depth_label').value=r.depth;this.update();}});this.classList.add('lc-ready');
      this.update();
      this.show(0, false);
      this.campaignTimer=setInterval(()=>{if(!this.isConnected){clearInterval(this.campaignTimer);return;}this.update();},60000);
    }
    priceInput() {
      const number = key => {const v=this.value(key);return v?Number(v.replace(',','.')):NaN;};
      return {
        handle:this.checked('pattern')?.dataset.product.split('/').pop(),
        shape:this.checked('form')?.dataset.code,
        length:number('length'),width:number('width'),depth:number('depth_label'),diameter:number('diameter'),
        ovalType:this.value('oval_type'),octagonType:this.value('octagon_type'),
        cutLength:number('cut_length'),cutWidth:number('cut_width'),floorArea:number('floor_area'),perimeter:number('perimeter'),
        stairs:!!this.checked('stairs')&&this.checked('stairs').dataset.code!=='none',slope:this.field('slope').checked,
        useStandardSize:this.querySelector('[data-standard-size]').value!==''
      };
    }
    field(key) { return this.querySelector('[data-key="' + key + '"]'); }
    checked(key) { return this.querySelector('[data-key="' + key + '"]:checked'); }
    value(key) { const el = this.field(key); return el?.type === 'radio' ? (this.checked(key)?.value || '') : (el?.value.trim() || ''); }
    toggle(el, show) {
      el.hidden = !show;
      el.querySelectorAll('input,select,textarea').forEach(input => { input.disabled = !show; });
    }
    measureError(input,message){
      const error=input.closest('label')?.querySelector('[data-measure-error]');
      if(!error)return;error.textContent=message;error.hidden=!message;input.setAttribute('aria-invalid',String(!!message));
    }
    valid(index) {
      if(index===2 && this.checked('form')?.dataset.code!=='rectangle') return true;
      const inputs = [...this.fields[index].querySelectorAll('input,select,textarea')].filter(el => !el.disabled);
      let first;
      if(index===2&&this.checked('stairs')?.dataset.code!=='none'&&!this.modelChoice){first=this.querySelector('[data-models] input');}
      inputs.forEach(el => {
        const decimal = el.inputMode === 'decimal';
        const ok = el.checkValidity() && (!decimal || (el.dataset.allowZero ? Number(el.value.replace(',', '.')) >= 0 : Number(el.value.replace(',', '.')) > 0));
        el.setAttribute('aria-invalid', String(!ok));
        if(el.dataset.measure)this.measureError(el,ok?'':'Ange ett mått större än 0 cm.');
        if (!ok && !first) first = el;
      });
      let geometryError='';
      if(index===1&&!first){
        const input=this.priceInput();
        if(input.shape!=='other'&&!(input.shape==='octagon'&&input.useStandardSize)&&!this.pricing.surfaceArea(input)){
          first=this.field(input.shape==='round'?'diameter':input.shape==='octagon'?(input.octagonType==='drawing'?'floor_area':'cut_length'):'length');
          geometryError=this.labels.geometry_error;first.setAttribute('aria-invalid','true');
        }
      }
      if(index===2&&!first&&!this.querySelector('[data-custom-stair]').hidden){
        const metrics=this.customMetrics();
        if(metrics.topDrop!==null&&metrics.topDrop<0){first=this.field('r1');geometryError='Steghöjdernas summa ('+metrics.riseSum+' cm) överstiger poolhöjden ('+metrics.depth+' cm). Kontrollera höjderna.';first.setAttribute('aria-invalid','true');this.measureError(first,geometryError);}
      }
      const error = this.querySelector('[data-error]');
      error.hidden = !first;
      error.textContent = first ? (geometryError||this.dataset.required) : '';
      if (first && !this.fields[index].hidden) first.focus();
      return !first;
    }
    show(index, focus = true) {
      if(index===2 && this.checked('form')?.dataset.code!=='rectangle') index=3;
      this.step = Math.max(0, Math.min(4, index));
      this.reached = Math.max(this.reached, this.step);
      this.fields.forEach((field, i) => { field.hidden = i !== this.step; });
      this.contact.hidden = this.step !== 4;
      this.querySelector('.lc-nav').hidden = this.step === 4;
      this.querySelector('[data-back]').hidden = this.step === 0;
      this.querySelector('[data-next]').textContent = this.step === 3 ? this.dataset.review : this.dataset.next;
      this.querySelectorAll('[data-jump]').forEach((b, i) => { b.disabled = i > this.reached; if (i === this.step) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current'); });
      if (focus) (this.step === 4 ? this.contact.querySelector(this.variantId?'[data-purchase] h2':'[data-quote] h2') : this.fields[this.step].querySelector('legend')).focus();
    }

    async buy(){
      if(this.buying)return;
      this.update();
      for(let i=0;i<4;i++){if(!this.valid(i)){this.show(i);this.valid(i);return;}}
      if(!this.variantId)return;
      this.buying=true;
      const button=this.querySelector('[data-buy]'),error=this.querySelector('[data-buy-error]');
      button.disabled=true;button.textContent=this.labels.adding;error.hidden=true;
      const properties={};
      this.fields.forEach(field=>field.querySelectorAll('input,select,textarea').forEach(el=>{
        if(el.disabled||!el.name||!el.value||(el.type==='radio'||el.type==='checkbox')&&!el.checked)return;
        const key=el.name.replace(/^contact\[/,'').replace(/\]$/,'');
        const names={form:'Poolform',length:'Längd cm',width:'Bredd cm',diameter:'Diameter cm',depth_label:'Pooldjup cm',stairs:'Trappa',pattern:'Mönster',model_notes:'Trappans avvikelser',shape_notes:'Poolformens detaljer'};
        properties[names[key]||this.labels[key]||key]=el.tagName==='SELECT'?el.selectedOptions[0].textContent:(el.value==='custom'?this.labels.custom:el.value);
      }));
      if(!this.querySelector('[data-custom-stair]').hidden)properties['Beräknade trappmått och kontroll']=this.customNotes().join(' ');
      properties['Produktionsstatus']=this.labels.production_status;
      properties['Pris före kampanj']=String(this.currentPrice.total)+' SEK';
      try{
        const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:this.variantId,quantity:1,properties}]})});
        if(!response.ok)throw new Error('cart');
        const result=await response.json();if(!result.items?.length)throw new Error('cart');
        location.assign((window.Shopify?.routes?.root||'/')+'cart');
      }catch{error.textContent=this.labels.buy_error;error.hidden=false;this.querySelector('[data-cart-link]').hidden=false;this.buying=false;button.disabled=false;button.textContent=this.labels.buy;}
    }
    renderModels(stairs){
      const box=this.querySelector('[data-models]');box.replaceChildren();if(!stairs||stairs==='none')return;
      const type=stairs==='full'?'full':'corner';
      const list=this.models.filter(m=>m.type===type).concat([{name:this.labels.custom,own:true}]);
      list.forEach(m=>{
        const label=document.createElement('label');label.className='lc-model';
        const radio=document.createElement('input');radio.type='radio';radio.name='contact[Trappmodell]';radio.value=m.own?'custom':m.name;radio.required=true;
        radio.addEventListener('change',()=>{this.modelChoice=radio.value;this.update();});
        const span=document.createElement('strong');span.textContent=m.name;
        label.append(radio,span);box.append(label);
      });
    }
    renderDimensionDrawing(stairs){
      const box=this.querySelector('[data-model-drawing]');
      const model=this.models.find(m=>m.name===this.modelChoice&&m.type===(stairs==='full'?'full':'corner'));
      const type=stairs==='full'?'full':'corner';
      const own=this.modelChoice==='custom';
      box.hidden=!model||own||!!model.custom;
      if(box.hidden)return;
      const key=own||model?.custom?'custom-'+type+'-'+this.field('step_count').value:model.id;
      this.querySelector('[data-model-drawing-title]').textContent=own?this.labels.custom_title:model.name;
      this.querySelector('[data-model-note]').textContent=own?this.labels.custom_hint:model.note;
      if(this.drawingKey!==key){this.drawingKey=key;this.querySelector('[data-dimension-drawing]').innerHTML=this.drawings[key];}
    }
    customMetrics(){
      const read=k=>{const el=this.field(k);if(!el||!el.value.trim()||!el.checkValidity())return null;const n=Number(el.value.replace(',','.'));return Number.isFinite(n)&&n>0?n:null;};
      const n=Number(this.field('step_count').value),depth=read('diagram_depth');
      const rises=Array.from({length:n},(_,i)=>read('r'+(i+1))),treads=Array.from({length:n},(_,i)=>read('d'+(i+1)));
      const riseSum=rises.every(x=>x!==null)?Math.round(rises.reduce((a,b)=>a+b,0)*100)/100:null;
      const totalDepth=treads.every(x=>x!==null)?Math.round(treads.reduce((a,b)=>a+b,0)*100)/100:null;
      const topDrop=depth!==null&&riseSum!==null?Math.round((depth-riseSum)*100)/100:null;
      const a=read('total_a'),b=read('total_b');
      const cornerReach=a&&b?a*b/Math.hypot(a,b):null;
      const cornerReview=cornerReach!==null&&totalDepth!==null&&Math.abs(cornerReach-totalDepth)>Math.max(1,cornerReach*.02);
      return {depth,riseSum,totalDepth,topDrop,cornerReview};
    }
    customNotes(){
      const m=this.customMetrics(),notes=[];
      if(m.topDrop!==null&&m.topDrop>=0)notes.push('Översta steget ligger '+m.topDrop+' cm under poolens överkant (beräknat).');
      if(m.totalDepth!==null)notes.push('Stegdjup totalt: '+m.totalDepth+' cm (beräknat).');
      if(this.checked('stairs')?.dataset.code!=='full'&&m.cornerReview)notes.push('Stegdjup och vägglängder behöver stämmas av mot ritning före produktion.');
      return notes;
    }
    renderCustom(stairs){
      const n=Number(this.field('step_count').value),box=this.querySelector('[data-stair-inputs]');
      const type=stairs==='full'?'full':'corner',key=type+'-'+n;
      if(this.customKey===key)return;
      this.measureCache=this.measureCache||{};
      if(this.customKey)this.measureCache[this.customKey]=Object.fromEntries([...box.querySelectorAll('input')].map(i=>[i.dataset.measure,i.value]));
      const old=this.measureCache[key]||{};this.customKey=key;box.replaceChildren();
      const addField=(parent,key,labelText)=>{
        const label=document.createElement('label');label.className='lc-field';label.append(document.createTextNode(labelText));
        const input=document.createElement('input');input.type='text';input.inputMode='decimal';input.pattern='[0-9]+([.,][0-9]+)?';input.required=true;input.dataset.measure=key;input.dataset.key=key;input.dataset.measureLabel=labelText;input.name='contact['+labelText+']';
        input.value=key==='diagram_depth'?this.field('depth_label').value:(old[key]||'');input.id=(this.form.id||'liner')+'-'+key;label.htmlFor=input.id;input.autocomplete='off';input.enterKeyHint='next';
        const error=document.createElement('small');error.dataset.measureError='';error.id=input.id+'-error';error.className='lc-measure-error';error.hidden=true;input.setAttribute('aria-describedby',error.id);
        label.append(input,error);parent.append(label);return input;
      };
      addField(box,'diagram_depth','Poolhöjd (cm)');
      const figure=document.createElement('figure');figure.className='lc-custom-overview';
      let path='M45 22 V210 H290',steps='';
      for(let i=0;i<n;i++){const x=45+i*210/n,y=62+i*148/n,w=210/n,h=148/n;path+=' M'+x+' '+y+' h'+w+' v'+h;steps+='<text x="'+(x+w/2)+'" y="'+(y+20)+'" text-anchor="middle">'+(i+1)+'</text>';}
      figure.innerHTML='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 235" role="img" aria-label="Trappa med '+n+' steg från sidan"><path d="'+path+'" fill="none" stroke="#12616d" stroke-width="2"/><g font-size="16" fill="#12333d">'+steps+'<text x="55" y="25">Poolens överkant</text><text x="205" y="232">Poolbotten</text></g></svg>';
      const caption=document.createElement('figcaption');caption.textContent='Från sidan. Steg 1 är överst. Principskiss, inte skalenlig.';figure.append(caption);box.append(figure);
      if(type==='corner'){
        const plan=document.createElement('figure');plan.className='lc-custom-overview';
        let cornerLines='M95 50 H280 L95 210 Z';for(let j=1;j<n;j++)cornerLines+=' M'+(95+185*j/n)+' 50 L95 '+(50+160*j/n);
        plan.innerHTML='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 230" role="img" aria-label="Hörntrappa ovanifrån, två totallängder längs väggarna"><path d="'+cornerLines+'" fill="none" stroke="#12616d" stroke-width="2"/><g font-size="16" fill="#12333d"><text x="115" y="32">Längs vägg 2</text><text x="7" y="124">Vägg 1</text></g></svg>';
        const c=document.createElement('figcaption');c.textContent='Mät från hörnet till nedersta stegets ytterkant längs varje vägg.';plan.append(c);box.append(plan);
        addField(box,'total_a','Totallängd längs vägg 1 (cm)');addField(box,'total_b','Totallängd längs vägg 2 (cm)');
        const hint=document.createElement('p');hint.className='lc-measure-note';hint.textContent='Stegdjup mäts vinkelrätt mot framkanten, inte längs väggen. Skissen gäller raka, parallella steg. Ange avvikande form i rutan nedan så stämmer vi av ritningen med dig.';box.append(hint);
      }else addField(box,'stair_width','Trappbredd längs kortsidan (cm)');
      for(let i=1;i<=n;i++){
        const card=document.createElement('div');card.className='lc-measure-step';const h=document.createElement('h4');h.textContent='Steg '+i+(i===1?' – överst':i===n?' – nederst':'');card.append(h);
        for(const axis of ['d','r']){
          const row=document.createElement('div');row.className='lc-measure-row';
          row.innerHTML=axis==='d'?'<svg viewBox="0 0 32 60" aria-hidden="true"><path d="M1 32 H30 V55 M1 20 H30 M1 16 V24 M30 16 V24" stroke="#12616d" fill="none" stroke-width="2"/></svg>':'<svg viewBox="0 0 32 60" aria-hidden="true"><path d="M1 7 H12 V52 H30 M25 7 V45 M21 7 H29 M21 45 H29" stroke="#12616d" fill="none" stroke-width="2"/></svg>';
          const text=axis==='d'?'Steg '+i+' – djup (cm)':'Steg '+i+(i===n?' – höjd till poolbotten (cm)':' – höjd till nästa steg (cm)');
          addField(row,axis+i,text);card.append(row);
        }box.append(card);
      }
      const result=document.createElement('p');result.className='lc-measure-result';result.dataset.derivedMeasures='';result.setAttribute('role','status');box.append(result);
      this.querySelectorAll('[data-pdf]').forEach(b=>b.closest('p').hidden=b.dataset.pdf!==type);
    }
    update() {
      const shape = this.checked('form')?.dataset.code;
      const rectangular=shape==='rectangle';
      this.toggle(this.field('slope').closest('label'),rectangular);
      if(!rectangular){this.field('slope').checked=false;this.querySelector('[data-key="stairs"][data-code="none"]').checked=true;this.modelChoice='';}
      this.fields[2].querySelectorAll('input,select,textarea').forEach(el=>el.disabled=!rectangular);
      this.querySelector('[data-jump="2"]').closest('li').hidden=!rectangular;
      this.querySelector('[data-jump="3"]').firstChild.textContent=rectangular?'4 ':'3 ';
      this.fields[3].querySelector('legend small').textContent=rectangular?'04':'03';
      const stairs = rectangular ? this.checked('stairs')?.dataset.code : 'none';
      if(this.priceShape!==shape){this.priceShape=shape;const select=this.querySelector('[data-standard-size]');while(select.options.length>1)select.remove(1);const seen=new Set();this.priceRows.forEach((r,i)=>{const key=[r.length,r.width,r.depth].join(' × ');if(r.shape===shape&&!seen.has(key)){seen.add(key);const o=document.createElement('option');o.value=i;o.textContent=key+' cm';select.append(o);}});}

      this.toggle(this.querySelector('[data-oval-geometry]'),shape==='oval');
      const ownOctagon=shape==='octagon'&&this.querySelector('[data-standard-size]').value==='';
      this.toggle(this.querySelector('[data-octagon-geometry]'),ownOctagon);
      this.toggle(this.querySelector('[data-octagon-cuts]'),ownOctagon&&this.value('octagon_type')==='symmetric');
      this.toggle(this.querySelector('[data-octagon-drawing]'),ownOctagon&&this.value('octagon_type')==='drawing');
      this.toggle(this.field('diameter').closest('label'), shape === 'round');
      ['length','width'].forEach(k => this.toggle(this.field(k).closest('label'), shape !== 'round'));
      this.toggle(this.field('shape_notes').closest('label'), shape === 'other');
      this.field('shape_notes').required = shape === 'other';
      this.toggle(this.querySelector('[data-stair-details]'), !!stairs && stairs !== 'none');
      if(this.lastStairs!==stairs){this.lastStairs=stairs;this.modelChoice='';this.renderModels(stairs);}
      const custom=stairs && stairs!=='none' && (this.modelChoice==='custom'||this.models.find(m=>m.name===this.modelChoice)?.custom);
      this.toggle(this.querySelector('[data-custom-stair]'),custom);
      if(custom){this.renderCustom(stairs);this.field('diagram_depth').value=this.field('depth_label').value;this.querySelector('[data-derived-measures]').textContent=this.customNotes().join(' ');}
      this.renderDimensionDrawing(stairs);
      this.querySelector('[data-slope-note]').hidden=!this.field('slope').checked;
      this.querySelector('[data-drawing-instruction]').hidden=!(this.field('slope').checked||custom||shape==='octagon');
      const dims = shape === 'round' ? (this.value('diameter') ? 'Ø ' + this.value('diameter') + ' cm' : '') : (this.value('length') && this.value('width') ? this.value('length') + ' × ' + this.value('width') + ' cm' : '');
      const choices = { form: this.value('form'), size: dims, depth: this.value('depth_label') ? this.value('depth_label') + ' cm' : '', stairs: this.value('stairs') + (stairs && stairs !== 'none' ? '\n' + (this.modelChoice==='custom'?this.labels.custom:this.modelChoice) : ''), fastening:this.value('fastening'), pattern: this.value('pattern') };
      const lines = [];
      Object.entries(choices).forEach(([key, value]) => { const target = this.querySelector('[data-summary="' + key + '"]'); target.textContent = value || this.dataset.empty; lines.push(target.previousElementSibling.textContent + ': ' + target.textContent); });
      ['shape_notes','model_notes'].forEach(key => { const field = this.field(key); if (!field.disabled && field.value.trim()) lines.push(field.parentElement.firstChild.textContent.trim() + ': ' + field.value.trim()); });
      const addons=(stairs&&stairs!=='none'?9000:0)+(this.field('slope').checked?5000:0);
      const addonText=this.labels.addons+': '+new Intl.NumberFormat('sv-SE').format(addons)+' kr';
      this.querySelector('[data-addons]').textContent=addonText;
      lines.push(addonText);
      if(this.field('slope').checked)lines.push(this.labels.slope,this.labels.slope_note);
      if(custom){this.querySelectorAll('[data-custom-stair] input,[data-custom-stair] select').forEach(el=>{if(!el.disabled)lines.push((el.dataset.measureLabel||el.closest('label').firstChild.textContent.trim())+': '+el.value);});}
      if(custom)lines.push(...this.customNotes());
      const product = this.checked('pattern');
      const fmt=n=>new Intl.NumberFormat('sv-SE',{maximumFractionDigits:2}).format(n)+' kr';
      const price=this.pricing.calculateLiner(this.priceRows,this.priceInput());
      this.currentPrice=price;
      this.variantId=price?.variantId||null;
      const priceText=price?fmt(price.discountedTotal):(!product?this.labels.pending_price:this.labels.quote);
      this.querySelector('.lc-price').textContent=priceText;
      this.querySelector('[data-mobile-price]').textContent=priceText;
      const areaNode=this.querySelector('[data-area-rate]');
      areaNode.hidden=!price||price.standard;
      if(price&&!price.standard){
        const area=new Intl.NumberFormat('sv-SE',{maximumFractionDigits:3}).format(price.area.total);
        areaNode.textContent=this.labels.area_label+': '+area+' m²\n'+this.labels.rate_label+': '+fmt(price.rate);
        lines.push(areaNode.textContent);
      }
      const promo=!!price?.campaignActive;
      this.querySelector('[data-original-price]').hidden=!promo;
      this.querySelector('[data-original-price]').textContent=promo?this.labels.before_campaign+': '+fmt(price.total):'';
      this.querySelector('[data-campaign-saving]').hidden=!promo;
      this.querySelector('[data-campaign-saving]').textContent=promo?this.labels.campaign_saving+': −'+fmt(price.total-price.discountedTotal):'';
      this.querySelectorAll('[data-liner-campaign]').forEach(el=>el.hidden=!this.pricing.campaignActive());
      this.querySelector('[data-purchase]').hidden=!this.variantId;
      this.toggle(this.querySelector('[data-quote]'),!this.variantId);
      this.querySelector('[data-quote-submit]').hidden=!!this.variantId;
      this.querySelector('[data-quote-submit]').disabled=!!this.variantId;
      this.querySelector('[data-order-heading]').textContent=price?this.labels.custom_order_title:this.labels.contact;
      this.querySelector('[data-order-hint]').textContent=price?this.labels.custom_order_hint:this.labels.quote_hint;
      this.querySelector('[data-quote-submit]').textContent=price?this.labels.custom_order_send:this.labels.send;
      if(price){
        lines.push(this.labels.base+': '+fmt(price.base),this.labels.price_total+': '+fmt(price.total));
        if(promo)lines.push(this.labels.campaign_saving+': '+fmt(price.discountedTotal),this.labels.campaign_until);
      }
      ['oval_type','octagon_type','cut_length','cut_width','floor_area','perimeter'].forEach(key=>{
        const el=this.field(key);if(el&&!el.disabled&&el.value)lines.push(this.labels[key]+': '+(el.tagName==='SELECT'?el.selectedOptions[0].textContent:el.value));
      });
      if (product?.dataset.product) lines.push(new URL(product.dataset.product, location.origin).href);
      lines.push(this.labels.promise);
      this.querySelector('[data-config]').value = lines.join('\n');
      const pool = this.querySelector('[data-pool]');
      pool.setAttribute('d',shape==='round'?'M150 20 A80 80 0 1 1 149.99 20 Z':shape==='oval'?'M150 10 C245 10 245 190 150 190 C55 190 55 10 150 10 Z':shape==='octagon'?'M105 15 H195 L220 40 V160 L195 185 H105 L80 160 V40 Z':'M90 10 H210 V190 H90 Z');
      const paths={left:'M90 70 L150 10 M90 50 L130 10 M90 30 L110 10',right:'M150 10 L210 70 M170 10 L210 50 M190 10 L210 30',full:'M90 30 H210 M90 50 H210 M90 70 H210'};
      this.querySelector('[data-stair-drawing]').setAttribute('d',shape==='round'||shape==='oval'||shape==='octagon'||shape==='other'?'':(paths[stairs]||''));
      this.querySelector('.lc-sketch').hidden = shape === 'other';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-cover-configurator"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  if (customElements.get('ph-cover')) return;
  class CoverConfigurator extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.form.noValidate = true;
      this.data = JSON.parse(this.querySelector('[data-cover-data]').textContent);
      this.text = this.data.text;
      const taSlats = this.data.models.find(model => model.key === 'top-one')?.series;
      if (taSlats) this.data.models.filter(model => model.mount === 'inpool' && model.key !== 'beach-line').forEach(model => {model.series = taSlats.map(series => ({...series,colors:series.colors.map(color => ({...color}))}));});
      this.money = cents => new Intl.NumberFormat(document.documentElement.lang || 'sv-SE', {style:'currency',currency:this.data.currency || 'SEK',maximumFractionDigits:0}).format(cents / 100);
      this.field = name => this.querySelector('[data-field="' + name + '"]');
      this.groupModel = {above:'sveltea',inpool:'beach-line'};
      this.quoteOpen = Boolean(this.querySelector('[data-quote-sent],[data-quote-form-errors]'));
      const requested = new URL(location.href).searchParams.get('cover_model') || this.data.defaultModel;
      if (this.data.mountScope === 'inpool') {this.field('width').value='';this.field('length').value='';}
      this.field('model').value = this.data.models.some(m => m.key === requested && (this.data.mountScope !== 'inpool' || m.mount === 'inpool')) ? requested : this.data.mountScope === 'inpool' ? 'beach-line' : this.data.models[0].key;
      this.querySelectorAll('[data-mount-choice]').forEach(button => button.addEventListener('click', () => {
        this.chooseModel(this.groupModel[button.dataset.mountChoice]);
      }));
      this.querySelectorAll('[data-model-choice]').forEach(button => button.addEventListener('click', () => this.chooseModel(button.dataset.modelChoice)));
      this.querySelectorAll('button[data-size]').forEach(button => button.addEventListener('click', () => {
        const [width,length] = button.dataset.size.split('x');
        this.field('width').value = width;
        this.field('length').value = length;
        this.field('measured').checked = false;
        this.querySelector('[data-test-review]').hidden = true;
        this.update();
      }));
      this.querySelector('[data-custom]').addEventListener('click', () => {
        this.field('width').focus();
        this.field('width').select();
      });
      const onChange = event => {
        if (event.target.matches('[data-roller-choice]')) this.field('roller').value = event.target.value;
        if (event.target.matches('[data-slat-choice]')) this.field('color').value = event.target.value;
        if (event.target.matches('[data-enclosure-choice]')) this.field('enclosure').value = event.target.value;
        if (event.target.matches('[data-cladding-choice]')) this.field('cladding').value = event.target.value;
        this.querySelector('[data-cart-error]').hidden = true;
        if (event.target.matches('[data-field="width"],[data-field="length"]')) this.field('measured').checked = false;
        this.querySelector('[data-test-review]').hidden = true;
        this.update();
      };
      this.addEventListener('input',onChange);
      this.addEventListener('change',onChange);
      this.querySelector('[data-submit]').addEventListener('click', () => this.order());
      this.querySelector('[data-quote-open]').addEventListener('click', () => this.setQuoteOpen(true));
      this.querySelector('[data-quote-close]').addEventListener('click', () => this.setQuoteOpen(false));
      this.form.addEventListener('submit', event => {
        if (this.quoteSending) {event.preventDefault();return;}
        this.update();
        if (!this.valid('quote')) {event.preventDefault();return;}
        this.trackJourney('quote_submit_attempted');
        if (this.data.testMode || this.data.previewOnly) {event.preventDefault();this.previewOrder(true);return;}
        this.quoteSending = true;
        this.querySelector('[data-quote-submit]').disabled = true;
        this.querySelector('[data-quote-submit]').textContent = this.text.quote_sending;
      });
      window.addEventListener('pageshow', event => {
        if (event.persisted) {this.quoteSending = false;this.update();}
      });
      this.querySelector('[data-review]').addEventListener('click', () => this.querySelector('[data-order-panel]').scrollIntoView({behavior:'smooth',block:'start'}));
      this.querySelector('[data-edit-test]').addEventListener('click', () => {
        this.querySelector('[data-test-review]').hidden = true;
        this.field('width').focus();
      });
      this.addEventListener('focusin', event => this.classList.toggle('is-editing', event.target.matches('input,textarea,select')));
      this.addEventListener('focusout', () => setTimeout(() => this.classList.toggle('is-editing', this.contains(document.activeElement) && document.activeElement.matches('input,textarea,select')),0));
      this.update();
    }
    chooseModel(key) {
      this.field('model').value = key;
      if (this.data.models.find(model => model.key === key)?.mount === 'inpool') this.field('model-help').checked = false;
      this.querySelector('[data-test-review]').hidden = true;
      this.update();
      this.trackJourney('model_selected');
    }
    setQuoteOpen(open) {
      this.quoteOpen = Boolean(open);
      this.querySelector('[data-cart-error]').hidden = true;
      this.update();
      if (this.quoteOpen) {
        this.trackJourney('quote_opened');
        this.querySelector('[data-quote-panel]').scrollIntoView({behavior:'smooth',block:'nearest'});
        (this.field('name').value.trim() ? this.field('quote-message') : this.field('name')).focus();
      } else this.querySelector('[data-quote-open]').focus();
    }
    trackJourney(event) {
      const state = this.state();
      window.PoolhandelJourney?.track(event,{journey:'lamell',model_id:this.model.key,variant_id:this.offer?.id,series:this.model.key === 'top-nova' ? (state.enclosure === 'Plus' ? 'nova-plus' : 'nova-light') : this.model.key,solar:state.material === 'solar',test_mode:Boolean(this.data.testMode || this.data.previewOnly)});
    }
    number(name) {
      const value = this.field(name).value.trim().replace(',','.');
      return /^\d+(\.\d{1,2})?$/.test(value) ? Number(value) : NaN;
    }
    selectedMaterial() {return this.querySelector('[name="contact[Lamelltyp]"]:checked').value;}
    setOptions(field,options,signature) {
      if (field.dataset.options === signature) return;
      const previous = field.value;
      field.replaceChildren(...options.map(value => new Option(value,value)));
      if (options.includes(previous)) field.value = previous;
      field.dataset.options = signature;
    }
    renderSlats(series) {
      const box = this.querySelector('[data-slat-colors]');
      box.dataset.count = String(series.colors.length);
      const signature = this.model.key + '-' + series.name;
      if (!series.colors.some(c => c.value === this.field('color').value)) this.field('color').value = series.colors[0].value;
      if (box.dataset.series !== signature) {
        box.replaceChildren(...series.colors.map(color => {
          const label = document.createElement('label');
          label.className = 'ph-cover-slat-card';
          const input = document.createElement('input');
          input.type = 'radio';input.name = 'slat-color-' + this.form.id;
          input.value = color.value;input.dataset.slatChoice = '';input.required = true;
          const image = document.createElement('img');
          image.src = color.image;image.alt = color.label;image.width = 400;image.height = 300;image.loading = 'lazy';
          const text = document.createElement('span');text.textContent = color.label;
          label.append(input,image,text);
          return label;
        }));
        box.dataset.series = signature;
      }
      box.querySelectorAll('input').forEach(input => {input.checked = input.value === this.field('color').value;});
      const selected = series.colors.find(c => c.value === this.field('color').value);
      this.querySelector('[data-slat-chosen]').textContent = this.text.slat_chosen.replace('{color}',selected.label);
    }
    renderFinishChoices(name,options,selector,choiceKey) {
      const box = this.querySelector(selector);
      const signature = this.model.key+'-'+name;
      if (!options.some(option => option.value === this.field(name).value)) this.field(name).value = options[0].value;
      if (box.dataset.options !== signature) {
        box.replaceChildren(...options.map(option => {
          const label = document.createElement('label');label.className = 'ph-cover-roller-card ph-cover-finish-card';
          const input = document.createElement('input');input.type = 'radio';input.name = 'cover-'+name+'-'+this.form.id;
          input.value = option.value;input.dataset[choiceKey] = '';
          const image = document.createElement('img');image.src = option.image;image.alt = option.label;image.width = 250;image.height = 250;image.loading = 'lazy';
          const text = document.createElement('span');text.textContent = option.label;
          label.append(input,image,text);return label;
        }));
        box.dataset.options = signature;
      }
      box.querySelectorAll('input').forEach(input => {input.checked = input.value === this.field(name).value;});
    }
    state() {
      return {model:this.model,width:this.number('width'),length:this.number('length'),material:this.selectedMaterial(),series:this.field('series').value,color:this.field('color').value,roller:this.field('roller').disabled ? '' : this.field('roller').value,cladding:this.field('cladding').disabled ? '' : this.field('cladding').value,enclosure:this.field('enclosure').disabled ? '' : this.field('enclosure').value,solarDrive:!this.field('solar-drive').disabled && this.field('solar-drive').checked,app:!this.field('app').disabled && this.field('app').checked,remote:!this.field('remote').disabled && this.field('remote').checked,special:this.field('special').checked,replacement:this.field('replacement').checked};
    }
    variants(model = this.model) {return this.data.testMode ? model.testVariants : model.liveVariants;}
    inpoolShipping() {
      const raw = String(this.data.inpoolShippingSEK ?? '').trim();
      if (!this.data.inpoolShippingConfirmed || !/^\d+(?:[.,]\d{1,2})?$/.test(raw)) return null;
      const amount = Math.round(Number(raw.replace(',','.')) * 100);
      return Number.isSafeInteger(amount) && amount >= 0 ? amount : null;
    }
    resolveInpoolOffer(state,requestedControl = null) {
      if (!this.data.inpoolOrderingEnabled || state.model.orderingEnabled !== true ||
          !['beach-line','classic-line'].includes(state.model.key) || state.model.pricePending || (this.data.testMode && !this.data.previewOnly) ||
          this.field('model-help').checked || state.special || state.replacement ||
          !(state.width > 0 && state.length > 0) || this.inpoolShipping() === null ||
          !String(this.data.inpoolPurchaseNote || '').trim() ||
          !Number.isSafeInteger(state.model.productId) || state.model.productId <= 0) return null;
      const installation = state.model.key === 'classic-line' ? this.field('classic').value : '';
      if (state.model.key === 'classic-line' && !['Normal vattennivå – balk','Hög vattennivå'].includes(installation)) return null;
      const control = requestedControl || (this.field('inpool-remote').checked ? 'Fjärrkontroll' : 'Standard');
      const priced = state.model.liveVariants.filter(v => !v.customOnly && v.series === state.series &&
        v.control === control && (v.installation || '') === installation &&
        Number.isSafeInteger(v.width) && v.width > 0 && Number.isSafeInteger(v.length) && v.length > 0);
      let width = state.width,length = state.length;
      if (state.model.key === 'beach-line') {
        if (!priced.length || width < Math.min(...priced.map(v=>v.width)) || length < Math.min(...priced.map(v=>v.length))) return null;
        width = Math.min(...priced.filter(v=>v.width>=state.width).map(v=>v.width));
        length = Math.min(...priced.filter(v=>v.length>=state.length).map(v=>v.length));
        if (!Number.isFinite(width) || !Number.isFinite(length)) return null;
      }
      const matches = priced.filter(v => v.width === width && v.length === length &&
        v.series === state.series && v.control === control &&
        (v.installation || '') === installation && Number.isSafeInteger(v.id) && v.id > 0 &&
        Number.isSafeInteger(v.price) && v.price > 0 && v.available === true);
      return matches.length === 1 ? matches[0] : null;
    }
    inpoolIncluded() {return this.model.key === 'beach-line' && this.model.orderingEnabled === true ? this.text.inpool_beach_included : this.text.inpool_safety_summary;}
    resolveOffer(state) {
      if (state.model.mount === 'inpool') return this.resolveInpoolOffer(state);
      if (!(state.width > 0 && state.length > 0) || state.special || state.replacement || state.model.pricePending || (state.app && state.remote)) return null;
      if (state.model.mount === 'above' && (state.width > 500 || state.length > 1000)) return null;
      if (!this.data.testMode && !this.data.orderingEnabled) return null;
      const controlKey = state.solarDrive ? 'solar' : state.app ? 'app' : state.remote ? 'remote' : 'none';
      const control = state.model.controls.find(c => c.key === controlKey);
      if (!control) return null;
      const all = this.variants(state.model);
      const exact = all.some(v => !v.customOnly && v.width === state.width && v.length === state.length);
      if (!exact && !this.data.customPricing) return null;
      const customOnly = state.model.key === 'sveltea' && !exact;
      const matches = all.filter(v => v.series === state.series && v.control === control.label &&
        v.enclosure === (state.model.key === 'top-nova' ? state.enclosure : '') &&
        v.customOnly === customOnly && Number.isSafeInteger(v.id) && v.id > 0 && v.price > 0 &&
        (this.data.testMode || v.available) && v.width >= state.width && v.length >= state.length &&
        (state.model.key !== 'sveltea' || customOnly || (v.width === state.width && v.length === state.length)));
      matches.sort((a,b) => a.width*a.length - b.width*b.length || a.width - b.width || a.length - b.length);
      return matches[0] || null;
    }
    updateModelCards() {
      this.querySelectorAll('[data-model-choice]').forEach(button => {
        const model = this.data.models.find(m => m.key === button.dataset.modelChoice);
        button.hidden = model.mount !== this.model.mount;
        button.setAttribute('aria-pressed',String(model.key === this.model.key && !(this.model.mount === 'inpool' && this.field('model-help').checked)));
        const baseControl = model.controls.find(c => c.key === 'none').label;
        const pool = this.variants(model).filter(v => v.control === baseControl && v.price > 0 &&
          !v.customOnly &&
          (this.data.testMode || v.available));
        const min = pool.length ? Math.min(...pool.map(v => v.price)) : 0;
        button.querySelector('[data-model-price]').textContent = model.pricePending || !min ? this.text.price_pending : this.text.from_price.replace('{price}',this.money(min));
      });
      this.querySelectorAll('[data-card-campaign]').forEach(el => {el.hidden = !this.data.campaignEnabled;});
    }
    update() {
      this.model = this.data.models.find(m => m.key === this.field('model').value) || this.data.models[0];
      this.groupModel[this.model.mount] = this.model.key;
      this.querySelectorAll('[data-mount-choice]').forEach(button => {
        button.setAttribute('aria-pressed',String(button.dataset.mountChoice === this.model.mount));
        button.hidden = button.dataset.mountChoice === 'inpool' && this.model.mount === 'above';
      });
      this.querySelector('.ph-cover-mounts').hidden = true;
      this.querySelector('[data-inpool-model-help]').hidden = this.model.mount !== 'inpool';
      this.querySelector('[data-inpool-bench-comparison]').hidden = this.model.mount !== 'inpool';
      this.updateModelCards();
      const taAbove = this.model.key === 'top-one' || this.model.key === 'top-nova';
      this.querySelector('[data-covrex-choice]').hidden = !taAbove && this.model.mount !== 'inpool';
      this.querySelectorAll('[name="contact[Lamelltyp]"]').forEach(input => {
        input.disabled = !this.model.series.some(series => series.material === input.value);
      });
      if (!this.model.series.some(series => series.material === this.selectedMaterial())) this.querySelector('[name="contact[Lamelltyp]"][value="pvc"]').checked = true;
      this.querySelector('.ph-cover-materials').dataset.ta = String(taAbove);
      this.querySelectorAll('[data-ta-material-image]').forEach(image => {image.hidden = !taAbove;});
      this.querySelector('[data-ta-safety-image]').hidden = !taAbove;
      const safetyImage = this.querySelector('[data-ta-safety-image]');
      safetyImage.src = this.selectedMaterial() === 'covrex' ? this.data.images.covrexSafetyLock : this.data.images.safetyLock;
      this.querySelector('[data-solar-drive-image]').src = this.model.key === 'top-nova' ? (this.field('enclosure').value === 'Plus' ? this.data.images.novaPlusSolar : this.data.images.novaLightSolar) : this.data.images.topOneSolar;
      const material = this.selectedMaterial();
      this.querySelector('[data-ta-pvc-note]').hidden = !taAbove || material !== 'pvc';
      const series = this.model.series.filter(s => s.material === material && !(this.model.key === 'top-nova' && this.field('enclosure').value === 'Light' && s.name === 'Premium PC solar'));
      this.setOptions(this.field('series'),series.map(s => s.name),this.model.key+'-'+material+'-'+this.field('enclosure').value);
      this.querySelector('[data-series-field]').hidden = series.length === 1;
      const selectedSeries = series.find(s => s.name === this.field('series').value) || series[0];
      this.renderSlats(selectedSeries);
      this.field('replacement').disabled = this.model.mount === 'inpool';
      this.field('replacement').closest('label').hidden = this.model.mount === 'inpool';
      if (this.model.mount === 'inpool') this.field('replacement').checked = false;
      const replacement = this.field('replacement').checked;
      const pricedBeach = this.model.key === 'beach-line' && this.model.orderingEnabled === true && !this.model.pricePending;
      this.querySelector('[data-custom-rule]').hidden = this.model.pricePending || replacement || (this.model.mount === 'inpool' && !pricedBeach);
      this.querySelector('[data-custom-rule]').textContent = pricedBeach ? this.text.inpool_beach_size_rule : this.text.custom_rule;
      const inpool = this.model.mount === 'inpool' && !replacement;
      this.field('width').required = !inpool;
      this.field('length').required = !inpool;
      const showRollerColors = this.model.rollers.length > 0 && !replacement;
      this.querySelector('[data-roller-heading]').textContent = taAbove ? this.text.ta_frame_heading : this.text.roller_heading;
      this.querySelector('[data-roller-hint]').textContent = taAbove ? this.text.ta_frame_hint : this.text.roller_hint;
      this.querySelector('[data-sveltea-frame-colors]').hidden = taAbove;
      this.querySelector('[data-ta-frame-colors]').hidden = !taAbove;
      this.querySelector('[data-cladding-field]').hidden = !taAbove || replacement;
      this.field('cladding').disabled = !taAbove || replacement;
      if (taAbove) {
        this.renderFinishChoices('roller',this.model.frameColors,'[data-ta-frame-colors]','rollerChoice');
        this.renderFinishChoices('cladding',this.model.claddings,'[data-cladding-colors]','claddingChoice');
      }
      if (this.model.rollers.length && !this.model.rollers.includes(this.field('roller').value)) this.field('roller').value = this.model.rollers[0];
      this.field('roller').disabled = !showRollerColors;
      this.querySelector('[data-roller-field]').hidden = !showRollerColors;
      this.querySelectorAll('[data-roller-choice]').forEach(input => {
        input.disabled = !showRollerColors || !this.model.rollers.includes(input.value);
        input.checked = input.value === this.field('roller').value;
      });
      this.querySelectorAll('[data-cladding-choice]').forEach(input => {input.disabled = !taAbove || replacement;});
      const enclosure = this.model.key === 'top-nova' && !replacement;
      this.querySelector('[data-enclosure-field]').hidden = !enclosure;
      this.field('enclosure').disabled = !enclosure;
      this.querySelectorAll('[data-enclosure-choice]').forEach(input => {
        input.disabled = !enclosure;
        input.checked = input.value === this.field('enclosure').value;
      });
      this.querySelector('[data-inpool-project]').hidden = !inpool;
      for (const name of ['project','depth','model-help','pool-structure','water-level','project-postcode','mechanism-space','inpool-remote']) this.field(name).disabled = !inpool;
      this.querySelector('[data-inpool-remote-label]').textContent = pricedBeach ? this.text.inpool_remote_option : this.text.inpool_remote_wish;
      this.querySelector('[data-inpool-control-note]').textContent = pricedBeach ? this.text.inpool_beach_control_note : this.text.inpool_control_note;
      this.querySelector('[data-beach-installation-note]').hidden = !inpool || this.model.key !== 'beach-line' || this.field('model-help').checked;
      this.querySelector('[data-inpool-remote-image]').hidden = !pricedBeach || !this.data.images.inpoolRemote;
      if (pricedBeach && this.data.images.inpoolRemote) this.querySelector('[data-inpool-remote-image]').src = this.data.images.inpoolRemote;
      this.querySelector('[data-beach-panel-image]').hidden = !pricedBeach;
      if (pricedBeach) {
        this.querySelector('[data-beach-panel-image]').src = this.data.images.beachPvcPanels;
        this.querySelector('[data-ta-safety-image]').hidden = false;
      }
      this.querySelector('[data-included-heading]').textContent = pricedBeach ? this.text.inpool_beach_included : this.text.safety;
      this.querySelector('[data-included-hint]').textContent = pricedBeach ? this.text.inpool_beach_package_note : this.text.safety_hint;
      this.field('depth').required = false;
      this.querySelector('[data-inpool-material-note]').hidden = !inpool;
      this.querySelector('[data-inpool-solar-note]').hidden = !inpool || material !== 'solar';
      const classic = inpool && this.model.key === 'classic-line';
      this.querySelector('[data-classic-field]').hidden = !classic;
      this.field('classic').disabled = !classic;
      this.querySelector('[data-control-options]').hidden = replacement || taAbove || inpool;
      this.field('control-standard').disabled = replacement;
      this.querySelector('[data-app-option]').hidden = taAbove || replacement || inpool;
      this.field('app').disabled = replacement || taAbove || inpool;
      if (taAbove || inpool) this.field('app').checked = false;
      if (inpool) this.field('remote').checked = false;
      this.querySelector('[data-solar-drive-option]').hidden = !taAbove || replacement;
      this.field('solar-drive').disabled = !taAbove || replacement;
      if (!taAbove || replacement) this.field('solar-drive').checked = false;
      this.field('remote').disabled = this.model.remoteIncluded || replacement;
      if (this.model.remoteIncluded) this.field('remote').checked = false;
      if (!this.field('app').checked && !this.field('remote').checked) this.field('control-standard').checked = true;
      this.field('control-standard').value = this.model.remoteIncluded ? 'Fjärrkontroll' : 'Standard';
      this.querySelector('[data-standard-control-label]').textContent = this.model.remoteIncluded ? this.text.remote : this.text.control_standard;
      this.querySelector('[data-standard-control-hint]').textContent = this.model.remoteIncluded ? this.text.control_remote_hint : this.text.control_standard_hint;
      this.querySelector('[data-remote-option]').hidden = this.model.remoteIncluded || replacement;
      this.querySelector('[data-app-option-price]').textContent = this.model.pricePending ? this.text.price_on_request : '+ '+this.money(this.model.controls.find(c => c.key === 'app')?.extra || 0);
      this.querySelector('[data-remote-option-price]').textContent = this.model.pricePending ? this.text.price_on_request : '+ '+this.money(this.data.remotePrice);
      this.querySelector('[data-model-description]').textContent = inpool && this.field('model-help').checked ? this.text.inpool_model_pending : this.model.description;
      this.querySelector('[data-campaign]').hidden = this.model.key !== 'sveltea' || !this.data.campaignEnabled || replacement;
      const state = this.state();
      const dimensions = Number.isFinite(state.width) && Number.isFinite(state.length) && state.width > 0 && state.length > 0;
      const inRange = dimensions && state.width <= 500 && state.length <= 1000;
      this.querySelector('[data-size-warning]').hidden = !dimensions || inRange || replacement || this.model.mount === 'inpool';
      this.querySelector('[data-solar-note]').hidden = material !== 'solar' || this.model.key !== 'sveltea';
      this.querySelector('[data-pc-premium]').hidden = this.model.pricePending || replacement || this.model.key !== 'sveltea';
      this.querySelector('[data-special-fields]').hidden = !state.special && !replacement;
      this.querySelector('[data-replacement-fields]').hidden = !replacement;
      this.field('existing').required = replacement;
      this.field('existing').disabled = !replacement;
      this.field('special-note').required = state.special;
      this.field('special-note').disabled = !state.special && !replacement;
      let exactSize = false;
      this.querySelectorAll('button[data-size]').forEach(button => {
        const [width,length] = button.dataset.size.split('x').map(Number);
        const selected = width === state.width && length === state.length;
        if (selected) exactSize = true;
        button.setAttribute('aria-pressed',String(selected));
        const offer = this.resolveOffer({...state,width,length,app:false,remote:false,solarDrive:false,special:false,replacement:false});
        const price = button.querySelector('[data-size-price]');
        price.hidden = !offer;
        price.textContent = offer ? this.money(offer.price) : '';
      });
      this.querySelector('[data-custom]').setAttribute('aria-pressed',String(dimensions && !exactSize));
      this.offer = this.resolveOffer(state);
      const inpoolStandard = inpool ? this.resolveInpoolOffer(state,'Standard') : null;
      const inpoolRemote = inpool ? this.resolveInpoolOffer(state,'Fjärrkontroll') : null;
      const inpoolRemoteExtra = inpoolStandard && inpoolRemote ? inpoolRemote.price-inpoolStandard.price : null;
      this.querySelector('[data-inpool-remote-price]').textContent = pricedBeach ? (inpoolRemoteExtra === null ? this.text.price_on_request : inpoolRemoteExtra === 0 ? this.text.included : (inpoolRemoteExtra > 0 ? '+ ' : '')+this.money(inpoolRemoteExtra)) : '';
      const standardOffer = taAbove ? this.resolveOffer({...state,solarDrive:false}) : null;
      const solarOffer = taAbove ? this.resolveOffer({...state,solarDrive:true}) : null;
      const solarExtra = solarOffer && standardOffer ? solarOffer.price - standardOffer.price : null;
      this.querySelector('[data-solar-drive-price]').textContent = solarExtra !== null ? '+ '+this.money(solarExtra) : this.text.price_on_request;
      for (const input of this.querySelectorAll('[data-enclosure-choice]')) {
        const light = this.resolveOffer({...state,enclosure:'Light'});
        const option = this.resolveOffer({...state,enclosure:input.value});
        this.querySelector('[data-enclosure-price="'+input.value+'"]').textContent = option && light ? (option.price === light.price ? this.text.included : '+ '+this.money(option.price-light.price)) : this.text.price_on_request;
      }
      const standardControl = this.model.controls.find(c => c.key === 'none').label;
      this.base = this.offer ? this.variants().find(v => v.series === state.series && v.width === this.offer.width && v.length === this.offer.length && v.control === standardControl && v.customOnly === this.offer.customOnly && v.enclosure === this.offer.enclosure) : null;
      this.discount = this.offer && this.model.key === 'sveltea' && this.data.campaignEnabled && !this.offer.customOnly ? Math.max(0,(this.offer.compareAtPrice || this.offer.price) - this.offer.price) : 0;
      this.shipping = this.offer ? (inpool ? this.inpoolShipping() : (this.model.shipping ?? this.data.shipping)) : 0;
      this.total = this.offer ? this.offer.price + this.shipping : null;
      const price = this.offer ? this.money(this.total) : this.text.quote_price;
      this.querySelectorAll('[data-cover-price]').forEach(el => {if (el.textContent !== price) el.textContent = price;});
      this.querySelector('[data-price-breakdown]').hidden = !this.offer;
      this.querySelector('[data-base-price]').textContent = this.base ? this.money(this.base.price + this.discount) : '—';
      this.querySelector('[data-discount-row]').hidden = !this.discount;
      this.querySelector('[data-discount-price]').textContent = this.discount ? '− '+this.money(this.discount) : '';
      this.querySelector('[data-app-row]').hidden = !this.offer || !state.app;
      this.querySelector('[data-remote-row]').hidden = !this.offer || !(inpool ? this.field('inpool-remote').checked : state.remote);
      this.querySelector('[data-solar-drive-row]').hidden = !this.offer || !state.solarDrive;
      this.querySelector('[data-solar-drive-breakdown]').textContent = this.offer && this.base ? this.money(this.offer.price - this.base.price) : '';
      this.querySelector('[data-app-price]').textContent = this.money(this.model.controls.find(c => c.key === 'app')?.extra || 0);
      this.querySelector('[data-remote-price]').textContent = inpool ? (this.offer && this.base ? this.money(this.offer.price-this.base.price) : '—') : this.money(this.data.remotePrice);
      this.querySelector('[data-shipping-price]').textContent = this.money(this.shipping);
      this.querySelector('[data-shipping-label]').textContent = inpool ? this.text.inpool_shipping : this.text.shipping;
      this.querySelector('[data-cover-price-note]').textContent = inpool ? (this.offer ? this.data.inpoolPurchaseNote : this.text.inpool_quote_price_note) : this.data.testMode ? this.text.test_price_note : this.offer ? (taAbove ? this.text.ta_purchase_note : this.data.purchaseNote) : this.text.quote_note;
      this.querySelector('[data-submit]').textContent = inpool ? this.text.inpool_buy : this.data.testMode ? this.text.test_order : this.text.buy;
      this.querySelector('[data-submit]').hidden = !inpool && !this.offer;
      this.querySelector('[data-submit]').disabled = Boolean(this.busy || this.quoteSending || (inpool && !this.offer));
      this.querySelector('[data-inpool-purchase-status]').hidden = !inpool || Boolean(this.offer);
      const quoteOnly = !this.offer;
      const inpoolQuote = this.model.mount === 'inpool' && quoteOnly;
      const showQuote = Boolean(this.quoteOpen);
      const quoteButton = this.querySelector('[data-quote-open]');
      quoteButton.hidden = false;
      quoteButton.textContent = inpool ? this.text.inpool_question_quote : this.text.quote_open;
      quoteButton.className = quoteOnly && !inpool ? 'ph-cover-submit' : 'ph-cover-secondary ph-cover-quote-toggle';
      quoteButton.setAttribute('aria-expanded',String(showQuote));
      this.querySelector('[data-quote-panel]').hidden = !showQuote;
      this.querySelector('[data-quote-close]').hidden = false;
      this.querySelector('[data-quote-submit]').hidden = !showQuote;
      this.querySelector('[data-quote-submit]').disabled = Boolean(this.quoteSending);
      this.querySelector('[data-quote-submit]').textContent = this.quoteSending ? this.text.quote_sending : inpoolQuote ? this.text.inpool_quote_send : this.text.quote_send;
      this.querySelector('[data-quote-heading]').textContent = inpoolQuote ? this.text.inpool_quote_title : this.text.quote_heading;
      this.querySelector('[data-quote-intro]').textContent = inpoolQuote ? this.text.inpool_quote_intro : this.text.quote_intro;
      this.querySelector('[data-contact-fields]').hidden = !showQuote;
      const quoteReason = this.querySelector('[data-quote-reason]');
      quoteReason.hidden = !quoteOnly || this.model.mount !== 'above';
      quoteReason.textContent = state.replacement ? this.text.quote_reason_replacement : state.special ? this.text.quote_reason_special : !dimensions ? this.text.quote_reason_missing : !inRange ? this.text.quote_reason_size : this.text.quote_reason_unavailable;
      this.field('measured').required = Boolean(this.offer);
      for (const name of ['name','email','phone','quote-message']) {
        this.field(name).required = showQuote && (name === 'name' || name === 'email' || name === 'quote-message');
        this.field(name).disabled = !showQuote;
      }
      this.querySelector('[data-summary-size]').textContent = dimensions ? state.width.toLocaleString('sv-SE')+' × '+state.length.toLocaleString('sv-SE')+' cm' : this.text.enter_size;
      this.querySelector('[data-summary-type]').textContent = state.series+' · '+state.color;
      this.querySelector('[data-summary-product]').textContent = replacement ? this.text.replacement_short : inpool && this.field('model-help').checked ? this.text.inpool_model_help : this.model.name;
      this.querySelector('[data-summary-roller]').textContent = replacement ? this.field('existing').value || '—' : this.model.key === 'top-nova' ? 'Top Nova '+(state.enclosure === 'Plus' ? 'Plus – heltäckt' : 'Light')+' · '+state.roller+' · '+state.cladding : taAbove ? state.roller+' · '+state.cladding : state.roller || this.model.name;
      this.querySelector('[data-summary-included]').textContent = inpool ? this.inpoolIncluded() : this.model.remoteIncluded && !state.app && !replacement ? this.text.included_remote_safety : this.text.safety;
      this.querySelector('[data-summary-control]').textContent = inpool ? (this.offer ? this.offer.control : this.field('inpool-remote').checked ? this.text.inpool_remote_wish : this.text.inpool_control_summary) : replacement ? '—' : state.solarDrive ? this.text.solar_drive_summary : state.app ? this.text.app : state.remote || this.model.remoteIncluded ? this.text.remote : this.text.control_standard;
      const customBand = this.offer && (state.width !== this.offer.width || state.length !== this.offer.length);
      this.querySelector('[data-price-band]').hidden = !customBand;
      this.querySelector('[data-price-band]').textContent = customBand ? this.text.custom_band.replace('{size}',this.offer.width+' × '+this.offer.length+' cm') : '';
      const campaignStatus = this.querySelector('[data-campaign-status]');
      campaignStatus.hidden = !this.offer || this.model.key !== 'sveltea' || !this.data.campaignEnabled;
      campaignStatus.textContent = this.discount ? this.text.campaign_applied : this.text.campaign_custom;
      this.querySelector('[data-contact-body]').value = this.quoteBody(state);
    }
    properties(state = this.state()) {
      const p = {'Produkt':state.replacement ? this.text.replacement_short : this.model.name,'Poolens minsta invändiga bredd (cm)':Number.isFinite(state.width) && state.width > 0 ? String(state.width) : this.text.not_entered,'Poolens invändiga längd (cm)':Number.isFinite(state.length) && state.length > 0 ? String(state.length) : this.text.not_entered,'Lamelltyp':state.series,'Lamellfärg':state.color,'Appstyrning':state.app ? (this.model.pricePending ? 'Önskas – pris i offert' : 'Vald') : 'Inte vald','Fjärrkontroll':this.model.remoteIncluded && !state.app && !state.replacement ? 'Ingår' : state.remote ? (this.model.pricePending ? 'Önskas – pris i offert' : 'Vald') : 'Inte vald','Säkerhetslås':'Ingår','Avvikande form eller hinder':state.special ? 'Ja – behöver granskas' : 'Nej','Mätkontroll':this.field('measured').checked ? 'Mätt på flera ställen; minsta bredden angiven' : 'Inte bekräftad','Före produktion':'Poolhandel kontaktar kunden och kontrollerar mått och utförande','Installation':this.field('installation').checked ? 'Önskar separat offert' : 'Inte vald'};
      if (state.model.key === 'top-one' || state.model.key === 'top-nova') p['Solcellsdrift'] = state.solarDrive ? 'Vald – fjärrkontroll ingår' : 'Inte vald';
      if (state.replacement) p['Befintlig upprullare'] = this.field('existing').value;
      else if (this.model.key === 'top-nova') p['Förvaringsbox'] = 'Top Nova '+(state.enclosure === 'Plus' ? 'Plus – heltäckt' : 'Light');
      else if (state.roller) p['Upprullarens färg'] = state.roller;
      if ((state.model.key === 'top-one' || state.model.key === 'top-nova') && !state.replacement) {
        p['Ställningens färg'] = state.roller;
        p['Panelbeklädnad'] = state.cladding;
      }
      if (this.model.mount === 'inpool' && !state.replacement) {
        p['Poolprojekt'] = this.field('project').value;
        p['Pooldjup (cm)'] = Number.isFinite(this.number('depth')) ? String(this.number('depth')) : this.text.inpool_measure_unknown;
        p['Produkt'] = this.field('model-help').checked ? this.text.inpool_model_help : this.model.name;
        p['Inbyggnad'] = this.field('model-help').checked ? this.text.inpool_model_help : this.model.name;
        p['Poolstomme'] = this.field('pool-structure').value;
        p['Vattennivå'] = this.field('water-level').value;
        p['Postnummer'] = this.field('project-postcode').value.trim() || this.text.not_entered;
        p['Utrymme och hinder'] = this.field('mechanism-space').value.trim() || this.text.not_entered;
        p['Fjärrkontroll'] = this.field('inpool-remote').checked ? (this.offer ? 'Vald – ingår i variantpriset' : 'Önskas – specificeras i offert') : 'Inte vald';
        p['Styrning'] = this.offer ? this.offer.control : this.text.inpool_control_summary;
        p['Säkerhetslås'] = this.model.key === 'beach-line' && this.model.orderingEnabled === true ? this.text.inpool_beach_safety : this.text.inpool_safety_summary;
        if (this.model.key === 'beach-line' && this.model.orderingEnabled === true) p['PVC-täckskivor'] = 'Ingår i paketpriset';
        p['Lamellval'] = this.offer ? 'Ingår i den prissatta konfigurationen' : 'Önskemål – kompatibilitet fastställs i offert';
        delete p['Appstyrning'];
        delete p['Upprullarens färg'];
        if (this.model.key === 'classic-line') p['Classic Line utförande'] = this.field('classic').value;
      }
      if (this.offer) {
        p['Prissatt måttgrupp (cm)'] = this.offer.width+' × '+this.offer.length;
        p['Frakt inom Sverige'] = this.money(this.shipping);
        p['Totalt inklusive frakt'] = this.money(this.total);
        if (this.discount) p['Kampanjrabatt på standardmått'] = '10 %: − '+this.money(this.discount);
        else if (this.offer.customOnly) p['Pris för egna mått'] = 'Ordinarie pris för vald storleksgrupp';
      }
      if (this.model.pricePending) p['Prisstatus'] = 'Pris på förfrågan';
      if (this.data.testMode) p['Testläge'] = 'Förhandsvisning – ingen beställning skickas';
      if (this.data.testMode && this.offer) p['Prisstatus'] = 'Fiktivt testpris';
      return p;
    }
    quoteDetails(state = this.state()) {
      const details = this.properties(state);
      details['Produktpris inklusive moms'] = this.offer ? this.money(this.offer.price) : this.text.price_on_request;
      details['Frakt inom Sverige'] = this.model.mount === 'inpool' ? (this.offer ? this.money(this.shipping) : this.text.inpool_no_fixed_shipping) : this.money(this.model.shipping ?? this.data.shipping);
      details['Totalt inklusive frakt'] = this.offer ? this.money(this.total) : this.text.quote_total_pending;
      details['Frågor eller specialönskemål'] = this.field('quote-message').value.trim() || this.text.not_entered;
      if ((state.special || state.replacement) && this.field('special-note').value.trim()) details['Övriga förutsättningar'] = this.field('special-note').value.trim();
      return details;
    }
    quoteBody(state = this.state()) {
      return this.text.quote_request_kind+'\n\n'+Object.entries(this.quoteDetails(state)).map(([key,value]) => key+': '+value).join('\n');
    }
    valid(mode = 'buy') {
      const quote = mode === 'quote';
      for (const name of ['name','email','phone','quote-message']) this.field(name).setCustomValidity('');
      if (quote) {
        this.field('name').setCustomValidity(this.field('name').value.trim() ? '' : this.text.quote_name_required);
        if (this.field('quote-message').required) this.field('quote-message').setCustomValidity(this.field('quote-message').value.trim() ? '' : this.text.quote_message_required);
      }
      const optionalDimensions = quote;
      const dimensions = [];
      for (const name of ['width','length','depth']) {
        const field = this.field(name);
        const omitted = (optionalDimensions || (name === 'depth' && !field.required)) && !field.value.trim();
        field.setCustomValidity(field.disabled || omitted || (Number.isFinite(this.number(name)) && this.number(name) > 0) ? '' : this.text.invalid_size);
        if (!omitted) dimensions.push(field);
      }
      const measured = this.field('measured');
      measured.setCustomValidity(!quote && measured.required && !measured.checked ? this.text.confirm_measurements : '');
      const configuration = [...this.querySelectorAll('input,select,textarea')].filter(field => !this.form.contains(field));
      const candidates = quote ? [...dimensions,...(this.model.mount === 'inpool' ? configuration.filter(field => field !== measured) : []),...['name','email','phone','quote-message'].map(name => this.field(name))] : configuration;
      const invalid = candidates.find(field => field.willValidate && !field.validity.valid);
      const error = this.querySelector('[data-cart-error]');
      if (invalid) {
        error.textContent = invalid.validationMessage;
        error.hidden = false;
        invalid.focus();
        invalid.reportValidity();
        return false;
      }
      error.hidden = true;
      return true;
    }
    order() {
      if (this.busy || this.quoteSending) return;
      this.update();
      if (!this.offer) {this.setQuoteOpen(true);return;}
      if (!this.valid('buy')) return;
      this.trackJourney('configuration_completed');
      if (this.data.testMode || this.data.previewOnly) this.previewOrder();
      else if (this.offer) this.buy();
    }
    previewOrder(quote = false) {
      const panel = this.querySelector('[data-test-review]');
      const list = panel.querySelector('dl');list.replaceChildren();
      const details = quote ? this.quoteDetails() : this.properties();
      if (quote) details['Ärende'] = this.text.quote_request_kind;
      for (const [key,value] of Object.entries(details)) {
        const dt=document.createElement('dt'),dd=document.createElement('dd');
        dt.textContent=key;dd.textContent=value;list.append(dt,dd);
      }
      panel.hidden=false;panel.scrollIntoView({behavior:'smooth',block:'start'});panel.focus({preventScroll:true});
    }
    async buy() {
      if (this.data.testMode || this.data.previewOnly || this.busy || this.quoteSending || !this.offer || this.model.pricePending) return;
      this.busy=true;
      const offer = this.offer, properties = this.properties();
      const button=this.querySelector('[data-submit]'),error=this.querySelector('[data-cart-error]');
      button.disabled=true;error.hidden=true;button.textContent=this.text.adding;
      try {
        const root=window.Shopify?.routes?.root || '/';
        const variantResponse=await fetch(root+'variants/'+offer.id+'.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
        if (!variantResponse.ok) throw new Error(this.text.cart_error);
        const variant=await variantResponse.json();
        if (!variant.available || variant.price !== offer.price) throw new Error(this.text.cart_error);
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:offer.id,quantity:1,properties}]})});
        const result=await response.json();
        if (!response.ok) throw new Error(result.description || this.text.cart_error);
        if (result.items?.some(item => Number(item.variant_id || item.id) === offer.id)) this.trackJourney('cart_add_success');
        location.assign((window.Shopify?.routes?.root || '/')+'cart');
      } catch (problem) {error.textContent=problem.message || this.text.cart_error;error.hidden=false;error.focus();}
      finally {this.busy=false;button.disabled=false;this.update();}
    }
  }
  customElements.define('ph-cover',CoverConfigurator);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-parts-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ph-parts-finder')) customElements.define('ph-parts-finder', class extends HTMLElement {
  connectedCallback() {
    if (this.events) return;
    let catalog;
    try {
      catalog = JSON.parse(this.querySelector('[data-index]').textContent);
      if (!Array.isArray(catalog.items)) throw new Error();
      if (this.dataset.scope && !Object.hasOwn(catalog.scopes || {}, this.dataset.scope)) throw new Error();
    } catch (error) {
      this.hidden = true;
      return;
    }
    this.hidden = false;
    this.events = new AbortController();
    this.generation = (this.generation || 0) + 1;
    this.normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
    this.categoryLabels = catalog.categories || {};
    this.items = catalog.items.map(item => {
      const strings = values => Array.isArray(values) ? values.filter(value => typeof value === 'string' && value) : [];
      const product = {
        ...item,
        categories: strings(item.categories),
        models: strings(item.models),
        codes: strings(item.codes),
        colors: strings(item.colors),
        component: typeof item.component === 'string' ? item.component : ''
      };
      product.normalized = this.normalize([product.search, product.title, product.brand, ...product.models, ...product.codes, ...product.categories.map(value => this.categoryLabel(value)), product.component, ...product.colors].join(' '));
      return product;
    });
    this.scope = catalog.scopes?.[this.dataset.scope] || {};
    const scopeHandles = Array.isArray(this.scope.handles) ? new Set(this.scope.handles) : null;
    this.baseItems = this.items.filter(product => scopeHandles ? scopeHandles.has(product.handle) : this.withinScope(product));
    this.q = this.querySelector('[data-query]');
    this.category = this.querySelector('[data-category]');
    this.brand = this.querySelector('[data-brand]');
    this.model = this.querySelector('[data-model]');
    this.component = this.querySelector('[data-component]');
    this.color = this.querySelector('[data-color]');
    this.list = this.querySelector('[data-results]');
    this.more = this.querySelector('[data-more]');
    this.resetFilters();
    this.applyUrlFilters();
    const options = { signal: this.events.signal };
    this.q.addEventListener('input', () => {
      this.model.value = '';
      this.refreshOptions();
      this.beginSearch(true);
    }, options);
    for (const select of [this.category, this.brand]) select.addEventListener('change', () => {
      this.model.value = '';
      this.refreshOptions();
      this.beginSearch();
    }, options);
    this.model.addEventListener('change', () => {
      this.q.value = '';
      this.refreshOptions();
      this.beginSearch();
    }, options);
    this.component.addEventListener('change', () => {
      this.refreshOptions();
      this.beginSearch();
    }, options);
    this.color.addEventListener('change', () => this.beginSearch(), options);
    this.querySelector('form').addEventListener('submit', event => {
      event.preventDefault();
      this.beginSearch();
    }, options);
    this.more.addEventListener('click', () => this.loadPage(this.generation), options);
    this.querySelector('[data-reset]').addEventListener('click', () => {
      this.resetFilters();
      this.beginSearch();
      this.q.focus();
    }, options);
    this.fallbacks = Array.from(this.closest('main')?.querySelectorAll('[data-ph-parts-fallback]') || []);
    this.fallbacks.forEach(element => { element.hidden = true; });
    this.querySelector('[data-controls]').hidden = false;
    this.beginSearch();
  }
  disconnectedCallback() {
    clearTimeout(this.timer);
    this.request?.abort();
    this.events?.abort();
    this.events = null;
    this.activeLoad = null;
    this.generation = (this.generation || 0) + 1;
    this.fallbacks?.forEach(element => { element.hidden = false; });
  }
  categoryLabel(value) {
    return this.categoryLabels[value] || value.replace(/-/g, ' ').replace(/^./, letter => letter.toUpperCase());
  }
  withinScope(product) {
    const tokens = String(this.scope.query || '').trim().split(/\s+/).map(this.normalize).filter(Boolean);
    return (!this.scope.category || product.categories.includes(this.scope.category)) &&
      (!this.scope.brand || product.brand === this.scope.brand) &&
      (!this.scope.model || product.models.includes(this.scope.model)) &&
      tokens.every(token => product.normalized.includes(token));
  }
  options(select, values, selected = select.value, label = value => value) {
    const unique = Array.from(new Set(values.filter(Boolean))).sort((a, b) => label(a).localeCompare(label(b), 'sv'));
    select.replaceChildren(new Option(this.dataset.all, ''), ...unique.map(value => new Option(label(value), value)));
    select.value = unique.includes(selected) ? selected : '';
  }
  refreshOptions(values = {}) {
    this.options(this.category, this.baseItems.flatMap(product => product.categories), values.category ?? this.category.value, value => this.categoryLabel(value));
    let products = this.baseItems.filter(product => !this.category.value || product.categories.includes(this.category.value));
    this.options(this.brand, products.map(product => product.brand), values.brand ?? this.brand.value);
    products = products.filter(product => !this.brand.value || product.brand === this.brand.value);
    this.options(this.model, products.flatMap(product => product.models), values.model ?? this.model.value);
    products = products.filter(product => !this.model.value || product.models.includes(this.model.value));
    this.options(this.component, products.map(product => product.component), values.component ?? this.component.value);
    products = products.filter(product => !this.component.value || product.component === this.component.value);
    this.options(this.color, products.flatMap(product => product.colors), values.color ?? this.color.value);
  }
  resetFilters() {
    this.q.value = this.scope.query || '';
    this.refreshOptions({ category: this.scope.category || '', brand: this.scope.brand || '', model: this.scope.model || '', component: '', color: '' });
  }
  applyUrlFilters() {
    const params = new URLSearchParams(window.location.search);
    const values = {};
    for (const key of ['category', 'brand', 'model']) {
      const value = params.get(key);
      if (!value) continue;
      const candidates = this.baseItems.filter(product =>
        (!values.category || product.categories.includes(values.category)) &&
        (!values.brand || product.brand === values.brand));
      if (candidates.some(product => key === 'category' ? product.categories.includes(value) : key === 'model' ? product.models.includes(value) : product.brand === value)) values[key] = value;
    }
    if (Object.keys(values).length) {
      this.refreshOptions({ category: values.category || this.category.value, brand: values.brand || this.brand.value, model: values.model || '', component: '', color: '' });
      if (values.model) this.q.value = '';
    }
  }
  beginSearch(debounce = false) {
    clearTimeout(this.timer);
    this.request?.abort();
    this.activeLoad = null;
    const generation = ++this.generation;
    this.offset = 0;
    this.rendered = new Set();
    this.list.replaceChildren();
    this.more.hidden = true;
    this.more.disabled = false;
    this.querySelector('[data-empty]').hidden = true;
    this.querySelector('[data-error-message]').hidden = true;
    const tokens = this.q.value.trim().split(/\s+/).map(this.normalize).filter(Boolean);
    const exact = this.normalize(this.q.value);
    this.matches = this.baseItems.filter(product =>
      (!this.category.value || product.categories.includes(this.category.value)) &&
      (!this.brand.value || product.brand === this.brand.value) &&
      (!this.model.value || product.models.includes(this.model.value)) &&
      (!this.component.value || product.component === this.component.value) &&
      (!this.color.value || product.colors.includes(this.color.value)) &&
      tokens.every(token => product.normalized.includes(token)));
    this.matches.sort((a, b) => Number(b.codes.some(code => this.normalize(code) === exact)) - Number(a.codes.some(code => this.normalize(code) === exact)) || a.title.localeCompare(b.title, 'sv'));
    this.querySelector('[data-count]').textContent = this.matches.length ? this.dataset.loading : this.countLabel();
    this.list.setAttribute('aria-busy', String(this.matches.length > 0));
    if (!this.matches.length) {
      this.querySelector('[data-empty]').hidden = false;
      return;
    }
    if (debounce) this.timer = setTimeout(() => this.loadPage(generation), 250);
    else this.loadPage(generation);
  }
  countLabel() {
    return this.matches.length === 1 ? this.dataset.one : this.dataset.countLabel.replace('{count}', String(this.matches.length));
  }
  async loadPage(generation) {
    if (generation !== this.generation || this.activeLoad?.generation === generation) return;
    const batch = this.matches.slice(this.offset, this.offset + 12);
    if (!batch.length) return;
    this.request?.abort();
    this.request = new AbortController();
    const load = { generation, offset: this.offset, controller: this.request };
    this.activeLoad = load;
    this.more.disabled = true;
    this.list.setAttribute('aria-busy', 'true');
    const url = new URL(this.dataset.resultsUrl, window.location.origin);
    url.searchParams.set('section_id', 'ph-parts-results');
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', batch.map(product => product.handle).join('|'));
    try {
      const response = await fetch(url, { signal: load.controller.signal, headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error();
      const resultDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (generation !== this.generation || this.activeLoad !== load) return;
      const results = resultDocument.querySelector('[data-parts-server-results]');
      if (!results) throw new Error();
      const cards = new Map(Array.from(results.querySelectorAll('[data-parts-card]')).map(card => [card.dataset.handle, card]));
      for (const product of batch) {
        const card = cards.get(product.handle);
        if (!card || this.rendered.has(product.handle)) continue;
        this.list.append(document.importNode(card, true));
        this.rendered.add(product.handle);
      }
      this.offset = load.offset + batch.length;
      this.more.hidden = this.offset >= this.matches.length;
      this.querySelector('[data-count]').textContent = this.countLabel();
      this.querySelector('[data-empty]').hidden = this.list.children.length > 0;
    } catch (error) {
      if (error.name === 'AbortError' || generation !== this.generation || this.activeLoad !== load) return;
      const message = this.querySelector('[data-error-message]');
      message.textContent = this.dataset.error;
      message.hidden = false;
      this.querySelector('[data-count]').textContent = '';
    } finally {
      if (generation === this.generation && this.activeLoad === load) {
        this.activeLoad = null;
        this.list.setAttribute('aria-busy', 'false');
        this.more.disabled = false;
      }
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-pool-configurator"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ph-pool')) customElements.define('ph-pool', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.config = JSON.parse(this.querySelector('[data-pool-config]').textContent);
    const textDecoder = document.createElement('textarea');
    for (const key of Object.keys(this.config.text)) {
      textDecoder.innerHTML = this.config.text[key];
      this.config.text[key] = textDecoder.value;
    }
    this.data = this.config.catalog;
    this.packages = JSON.parse(this.querySelector('[data-pool-packages]').textContent);
    this.order = JSON.parse(this.querySelector('[data-pool-order]').textContent);
    this.packages.components.watersens.price = 2199000;
    const additions = JSON.parse(this.querySelector('[data-miami-additions]').textContent);
    Object.assign(this.data.miamiOptions, additions.options);
    for (const [size, groups] of Object.entries(additions.groups)) Object.assign(this.data.miamiGroups[size] || (this.data.miamiGroups[size] = {}), groups);
    this.data.version += '+'+additions.version;
    this.data.sourceDate = additions.sourceDate;
    this.models = new Map(this.data.models.map(model => [model.id, model]));
    this.q = selector => this.querySelector(selector);
    this.t = key => this.config.text[key] || key;
    this.esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    this.money = value => new Intl.NumberFormat('sv-SE', {style:'currency', currency:'SEK', maximumFractionDigits:value % 100 ? 2 : 0}).format(value / 100);
    this.key = 'poolhandel-poolvaljare-2026-09-13-v1';
    this.state = this.initial();
    this.filter = 'all';
    this.restore();
    const params = new URLSearchParams(location.search);
    const requested = this.requestedModel(this.config.productHandle, params.get('modell'));
    const type = params.get('pooltyp') || this.config.startType;
    if (requested) this.chooseModel(requested.id, false);
    else if (['thermo','tra','glasfiber','stal'].includes(type) && this.state.type !== type) this.chooseType(type, false);
    const sizeSlugs={'3x6':[300,600],'3-5x7':[350,700],'4x7-5':[400,750],'4x8':[400,800],'4x10':[400,1000],'5x10':[500,1000]};
    const requestedSize=sizeSlugs[this.dataset.sizePage || params.get('storlek')];
    if(requestedSize){
      this.chooseType('thermo',false);
      const size=this.model()?.sizes.find(s=>s.width===requestedSize[0]&&s.length===requestedSize[1]);
      if(size)Object.assign(this.state,{size:size.id,width:String(size.width),length:String(size.length),height:String(size.height),custom:false,step:2});
    }
    if(params.get('paket') && ['standard','premium','luxury'].includes(params.get('paket')))this.applyStarter(params.get('paket'),false);
    this.abort = new AbortController();
    const eventOptions = {signal:this.abort.signal};
    this.addEventListener('click', event => this.onClick(event), eventOptions);
    this.addEventListener('input', event => this.onInput(event), eventOptions);
    this.addEventListener('change', event => this.onChange(event), eventOptions);
    this.addEventListener('submit', event => {
      if (!event.target.matches('.pool-contact-form')) return;
      if (this.config.testMode || !this.validConfiguration(true)) { event.preventDefault(); return; }
      const body = this.q('[data-contact-body]');
      if (body) body.value = this.summaryText();
      window.PoolhandelJourney?.track('quote_submit_attempted', {journey:'pool',model_id:this.state.model,pool_type:this.state.type,test_mode:this.config.testMode});
    }, eventOptions);
    this.addEventListener('focusin', event => {
      if (event.target.matches('input:not([type=checkbox]):not([type=radio]),textarea')) this.classList.add('pool-editing');
    }, eventOptions);
    this.addEventListener('focusout', () => this.classList.remove('pool-editing'), eventOptions);
    this.q('[data-send]').disabled = false;
    this.render();
    this.renderStarters();
    this.previewGap = () => {
      const bar = document.querySelector('#preview-bar-iframe');
      const rect = bar?.getBoundingClientRect();
      const height = rect && rect.top < innerHeight && rect.bottom > 0 ? Math.min(rect.height, 90) : document.querySelector('#PBarNextFrame') ? 72 : 0;
      this.style.setProperty('--pool-preview-gap', height + 'px');
    };
    this.previewGap();
    window.addEventListener('resize', this.previewGap, eventOptions);
    if ('MutationObserver' in window) {
      this.previewObserver = new MutationObserver(this.previewGap);
      this.previewObserver.observe(document.body, {childList:true});
    }
    if ('IntersectionObserver' in window) {
      this.visibilityObserver = new IntersectionObserver(entries => { this.q('[data-mobile-bar]').hidden = !entries[0].isIntersecting; });
      this.visibilityObserver.observe(this.q('.pool-workspace'));
    }
  }

  disconnectedCallback() { this.abort?.abort(); this.previewObserver?.disconnect(); this.visibilityObserver?.disconnect(); this.ready = false; }
  applyStarter(tier,update=true){
    if(!['standard','premium','luxury'].includes(tier)||this.model()?.type!=='thermo')return;
    Object.assign(this.state,{detailPackage:tier,circulationPackage:tier,carePackage:tier,coverPackage:tier==='luxury'?'nova':'bar',heatPackage:this.packageDimensions()?.small?'heat-procube-9':'heat-procube-16',automationPackage:'none',stairPackage:'ladder',linerPackage:'adriatic',service:'self'});
    if(update){this.render();this.go(3);}
  }
  renderStarters(){
    const target=this.q('[data-pool-starters]');if(!target)return;target.closest('section').hidden=this.model()?.type!=='thermo';if(this.model()?.type!=='thermo')return;
    const saved=JSON.parse(JSON.stringify(this.state));
    target.innerHTML=['standard','premium','luxury'].map(tier=>{
      this.state=JSON.parse(JSON.stringify(saved));this.applyStarter(tier,false);
      const calc=this.calculation(),ready=this.purchaseStatus().ready;
      const rows=this.packageGroups().map(g=>this.packageOptions(g).find(o=>o.id===this.state[g])).filter(Boolean);
      return '<article><h3>'+this.esc(this.t('starter_'+tier))+'</h3><p class="pool-price">'+this.esc(ready?this.money(calc.subtotal):this.t('starter_unavailable'))+'</p><details><summary>'+this.esc(this.t('pk_included'))+'</summary><ul>'+rows.map(o=>'<li>'+this.esc(o.title)+'</li>').join('')+'</ul></details><p class="pool-small">'+this.esc(this.t('starter_price_note'))+'</p><button class="btn btn--primary" type="button" data-starter="'+tier+'">'+this.esc(this.t('starter_choose'))+'</button></article>';
    }).join('');this.state=saved;
  }

  initial() { return {step:1, type:'', model:'', size:'', custom:false, width:'300', length:'600', height:'150', orientation:'left', finish:'3D Marble White', color:'', choices:{}, optionColors:{}, quantities:{}, cover:'help', service:'self', placement:'help', when:'plan', notes:'', tech:'help', light:'none', care:'help', robot:'none', heat:'help', linerWish:'help', stairWish:'help', detailPackage:'help', circulationPackage:'help', coverPackage:'help', carePackage:'help', automationPackage:'none', heatPackage:'help', linerPackage:'help', stairPackage:'help'}; }
  model() { return this.models.get(this.state.model); }
  size() { return this.model()?.sizes.find(s => s.id === this.state.size); }
  number(value) { const str = String(value ?? '').trim(); return /^\d+(?:[.,]\d{1,2})?$/.test(str) && +str.replace(',','.') > 0 && +str.replace(',','.') <= 10000 ? +str.replace(',','.') : null; }
  image(url, width = 650) { if (!url) return ''; const u = new URL(url, location.origin); if (u.hostname.includes('shopify')) u.searchParams.set('width', String(width)); return this.esc(u.href); }
  stateProject() { return Object.fromEntries(['service','placement','when','notes'].map(k => [k,this.state[k]])); }

  restore() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(this.key));
      if (!saved || typeof saved !== 'object') return;
      saved.model = this.data.modelAliases?.[saved.model] || saved.model;
      if (!this.models.has(saved.model)) return;
      const model = this.models.get(saved.model);
      const result = this.initial();
      for (const key of Object.keys(result)) {
        if (['choices','optionColors','quantities'].includes(key)) continue;
        if (typeof saved[key] === typeof result[key]) result[key] = typeof saved[key] === 'string' ? saved[key].slice(0,1600) : saved[key];
      }
      result.type = model.type;
      result.step = Math.max(1, Math.min(4, Math.floor(result.step) || 1));
      result.custom = model.type === 'glasfiber' || model.fixedSizes ? false : result.custom;
      if (model.id === 'trapool-projekt' && (Math.min(+result.width,+result.length) > 400 || Math.max(+result.width,+result.length) > 800)) { result.custom = false; result.size = 'tra-400x800'; }
      if (model.sizes.length && !model.sizes.some(s => s.id === result.size)) result.size = model.sizes.find(s => !s.mirror)?.id || model.sizes[0].id;
      if (!this.data.gjColors.includes(result.finish)) result.finish = '3D Marble White';
      result.choices = Object.fromEntries(Object.entries(saved.choices || {}).map(([key,value]) => [key,typeof value === 'string' ? value.replace(/^(details|lighting|transformer)-wide-aurex-/, '$1-wide-classic-') : value]).filter(([key,value]) => this.optionGroups().includes(key) && typeof value === 'string' && (value === 'help' || this.data.miamiOptions[value])));
      result.optionColors = Object.fromEntries(Object.entries(saved.optionColors || {}).filter(([key,value]) => this.optionGroups().includes(key) && typeof value === 'string'));
      result.quantities = Object.fromEntries(Object.entries(saved.quantities || {}).filter(([key,value]) => this.optionGroups().includes(key) && Number.isInteger(value) && value > 0));
      this.state = result;
      const fixed = this.size();
      if (!this.state.custom && fixed) for (const field of ['width','length','height']) this.state[field] = String(fixed[field] ?? '');
      if (model.type === 'glasfiber' && this.state.coverPackage === 'beach') this.state.coverPackage = 'help';
      this.normalizePlacement();
      if (model.subtype === 'garden' && ['end','corner'].includes(this.state.stairPackage)) this.state.stairPackage = 'special';
      this.cleanOptions();
    } catch { this.state = this.initial(); }
  }

  persist() { try { sessionStorage.setItem(this.key, JSON.stringify(this.state)); } catch {} }
  chooseType(type, update = true) {
    if (!['thermo','tra','glasfiber','stal'].includes(type)) return;
    this.state = {...this.initial(), ...this.stateProject(), type};
    this.filter = 'all';
    if (type === 'tra') this.chooseModel('trapool-projekt', false);
    if (type === 'thermo') this.chooseModel('poolhandels-kompletta-poolpaket-bas', false);
    if (update) { this.q('[data-error]').hidden = true; this.render(); if (!this.model()) this.focusModels(); }
  }

  chooseModel(id, update = true) {
    id = this.data.modelAliases?.[id] || id;
    const model = this.models.get(id);
    if (!model) return;
    this.state = {...this.initial(), ...this.stateProject(), type:model.type, model:id, cover:model.kind === 'package' ? 'package' : 'help', linerWish:model.kind === 'package' ? 'package' : 'help', stairWish:model.kind === 'package' ? 'package' : 'help'};
    const size = model.sizes.find(s => !s.mirror) || model.sizes[0];
    if (size) Object.assign(this.state, {size:size.id, width:String(size.width ?? ''), length:String(size.length ?? ''), height:String(size.height ?? '')});
    else this.state.custom = true;
    this.normalizePlacement();
    if (update) { this.q('[data-error]').hidden = true; this.q('[data-notice]').hidden = true; this.render(); this.go(2); window.PoolhandelJourney?.track('model_selected', {journey:'pool',model_id:id,pool_type:model.type,test_mode:this.config.testMode}); }
  }

  chooseSize(id) {
    const size = this.model()?.sizes.find(s => s.id === id);
    if (!size) return;
    Object.assign(this.state, {size:id, custom:false, width:String(size.width), length:String(size.length), height:String(size.height), choices:{}, optionColors:{}, quantities:{}, color:''});
    this.notice('size_reset');
    this.render();
  }

  optionGroups() { return ['heat','equipment','details','lighting','transformer','stairs','liner','cover','winter']; }
  selectedOptions() { return Object.values(this.state.choices).map(key => this.data.miamiOptions[key]).filter(Boolean); }
  availableOptions(group) {
    if (this.model()?.type !== 'stal') return [];
    const ids = this.state.custom ? (group === 'heat' ? ["heat-calidi-pp11","heat-calidi-pp18","heat-procube-9","heat-procube-12","heat-procube-16","heat-none"] : group === 'cover' ? ['cover-none','cover-other'] : []) : this.data.miamiGroups[this.state.size]?.[group] || [];
    const chosenIds = new Set(this.selectedOptions().map(o => o.id));
    const stair = this.data.miamiOptions[this.state.choices.stairs];
    const requiredLiners = stair?.requires ? stair.requires.split(',').map(value => value.split(':')[0]) : [];
    const details = this.data.miamiOptions[this.state.choices.details];
    if (details?.luxuryBundle && ['lighting','transformer'].includes(group)) return [group+'-wide-classic-included'];
    const available = group === 'details' && !this.state.custom ? [...ids,'details-wide-classic-'+(this.packageDimensions()?.small ? 1 : 2)] : ids;
    return available.filter(key => {
      const option = this.data.miamiOptions[key];
      if (!option) return false;
      const awaitingDetails = ['lighting','transformer'].includes(group) && !details;
      if (option.showIf.length && !awaitingDetails && !option.showIf.some(id => chosenIds.has(id))) return false;
      if (group === 'liner' && requiredLiners.length && !requiredLiners.includes(option.id)) return false;
      return true;
    });
  }

  selectedColor(group, option) {
    return option?.colors.find(c => c.id === (group === 'liner' ? this.state.color : this.state.optionColors[group]));
  }

  optionQuantity(group, option) {
    const requested = Number(this.state.quantities[group]);
    return Math.max(option?.minQuantity || 1, Math.min(option?.maxQuantity || 1, Number.isInteger(requested) ? requested : option?.quantity || 1));
  }

  optionRegularPrice(group, option) {
    const unit = this.selectedColor(group, option)?.price ?? option?.price;
    return Number.isFinite(unit) ? unit * this.optionQuantity(group, option) : null;
  }

  miamiCampaignActive() {
    const campaign = this.order.miamiStairCampaign;
    const now = Date.now();
    return !!campaign?.enabled && now >= Date.parse(campaign.startsAt) && now <= Date.parse(campaign.endsAt);
  }

  miamiStairFree(group, option) {
    const model = this.model(), campaign = this.order.miamiStairCampaign;
    return group === 'stairs' && model?.type === 'stal' && model.vendor === 'Miami Pool'
      && this.miamiCampaignActive() && campaign.supplierIds.includes(String(option?.id))
      && Number.isFinite(this.optionRegularPrice(group, option));
  }

  optionPrice(group, option) {
    return this.miamiStairFree(group, option) ? 0 : this.optionRegularPrice(group, option);
  }

  campaignPriceMarkup(regularPrice) {
    return '<div class="pool-campaign-price"><span>'+this.esc(this.t('miami_campaign_regular'))+' <s>'+this.esc(this.money(regularPrice))+'</s></span><strong>'+this.esc(this.t('miami_campaign_free'))+'</strong><small>'+this.esc(this.t('miami_campaign_title')+' · '+this.t('miami_campaign_saving')+' '+this.money(regularPrice))+'</small></div>';
  }

  calculationLinePrice(line) {
    return line.campaignFree ? this.t('miami_campaign_free')+' · '+this.t('miami_campaign_title') : this.money(line.price);
  }

  cleanOptions() {
    if (this.data.miamiOptions[this.state.choices.details]?.luxuryBundle) Object.assign(this.state.choices,{lighting:'lighting-wide-classic-included',transformer:'transformer-wide-classic-included'});
    for (const group of ['details','equipment','stairs','liner','heat','lighting','transformer','cover','winter']) {
      const key = this.state.choices[group];
      if (key && key !== 'help' && !this.availableOptions(group).includes(key)) {
        this.state.choices[group] = 'help';
        delete this.state.quantities[group];
        delete this.state.optionColors[group];
      }
      const option = this.data.miamiOptions[this.state.choices[group]];
      if (group !== 'liner' && option?.colors.length && !option.colors.some(c => c.id === this.state.optionColors[group])) this.state.optionColors[group] = option.colors[0].id;
    }
    const liner = this.data.miamiOptions[this.state.choices.liner];
    if (!liner?.colors.some(c => c.id === this.state.color)) this.state.color = '';
  }

  setOption(group, key) {
    if (!this.optionGroups().includes(group) || (key !== 'help' && !this.availableOptions(group).includes(key))) return;
    const oldLiner = this.state.choices.liner;
    const option = this.data.miamiOptions[key];
    if (['lighting','transformer'].includes(group) && option?.showIf.length && !this.data.miamiOptions[this.state.choices.details]) {
      const detailKey = this.availableOptions('details').find(k => option.showIf.includes(this.data.miamiOptions[k].id));
      if (detailKey) { this.state.choices.details = detailKey; this.notice('details_selected'); }
    }
    this.state.choices[group] = key;
    delete this.state.quantities[group];
    delete this.state.optionColors[group];
    if (group === 'liner') this.state.color = '';
    this.cleanOptions();
    if (oldLiner && oldLiner !== this.state.choices.liner) this.notice('liner_reset');
    this.renderEquipment();
    this.renderSummary();
    this.persist();
  }

  renderMiamiGroup(group) {
    const selected = this.state.choices[group] || 'help';
    const available = this.availableOptions(group);
    const help = '<option value="help"'+(selected === 'help' ? ' selected' : '')+'>'+this.esc(this.t('help_choose'))+'</option>';
    const choices = available.map(key => {
      const option = this.data.miamiOptions[key];
      const priceLabel = this.miamiStairFree(group,option) ? this.t('miami_campaign_free')+' · '+this.t('miami_campaign_title') : !Number.isFinite(option.price) ? this.t('option_quote') : option.price ? this.money(option.price) : this.t('no_addition');
      return '<option value="'+this.esc(key)+'"'+(selected === key ? ' selected' : '')+'>'+this.esc(option.name+' · '+priceLabel)+'</option>';
    }).join('');
    let output = '<div class="pool-field-block"><label>'+this.esc(this.t('g_'+group))+'<select data-group="'+group+'">'+(group === 'heat' ? choices+help : help+choices)+'</select></label>';
    const option = this.data.miamiOptions[selected];
    if (option?.image && group !== 'liner') output += '<div class="pool-option-preview"><img width="84" height="68" loading="lazy" src="'+this.esc(option.image)+'" alt=""><span>'+this.esc(option.name)+'</span></div>';
    if (this.miamiStairFree(group,option)) output += this.campaignPriceMarkup(this.optionRegularPrice(group,option));
    if (option?.maxQuantity > 1) output += '<label class="pool-option-detail">'+this.esc(this.t('option_quantity'))+'<select data-quantity-group="'+group+'">'+Array.from({length:option.maxQuantity-option.minQuantity+1},(_,index)=>index+option.minQuantity).map(n=>'<option value="'+n+'"'+(this.optionQuantity(group,option)===n?' selected':'')+'>'+n+'</option>').join('')+'</select></label>';
    if (group === 'liner' && option?.colors.length) output += '<h4>'+this.esc(this.t('color'))+'</h4><div class="pool-colors">'+option.colors.map(color => '<button type="button" class="pool-color" data-color="'+this.esc(color.id)+'" aria-pressed="'+(this.state.color === color.id)+'"><img src="'+this.esc(this.data.linerImages[color.name])+'" width="100" height="70" loading="lazy" alt=""><span>'+this.esc(color.name)+'</span></button>').join('')+'</div>';
    if (group !== 'liner' && option?.colors.length) output += '<label class="pool-option-detail">'+this.esc(this.t('color'))+'<select data-color-group="'+group+'">'+option.colors.map(color => '<option value="'+this.esc(color.id)+'"'+(this.state.optionColors[group]===color.id?' selected':'')+'>'+this.esc(color.name+' · '+this.money(color.price))+'</option>').join('')+'</select></label>';
    if (option?.mountingQuote) output += '<p class="pool-small">'+this.esc(this.t('pk_aurex_fitting'))+'</p>';
    if (group === 'lighting') output += '<p class="pool-small">'+this.esc(this.t('lighting_note'))+'</p>';
    if (group === 'transformer') output += '<p class="pool-small">'+this.esc(this.t('transformer_note'))+'</p>';
    if (group === 'heat') output += '<p class="pool-small">'+this.esc(this.t('heat_note'))+'</p>';
    if (group === 'cover') output += '<p class="pool-small">'+this.esc(this.t(selected === 'cover-other' ? 'cover_other_note' : 'cover_note'))+'</p>';
    return output+'</div>';
  }

  onClick(event) {
    const button = event.target.closest('button');
    if (!button || !this.contains(button)) return;
    if (button.hasAttribute('data-starter')) { this.applyStarter(button.dataset.starter); return; }
    if (button.hasAttribute('data-buy')) { this.addPoolToCart(); return; }
    if (button.hasAttribute('data-type')) this.chooseType(button.dataset.type);
    else if (button.hasAttribute('data-model')) this.chooseModel(button.dataset.model);
    else if (button.hasAttribute('data-size')) this.chooseSize(button.dataset.size);
    else if (button.hasAttribute('data-preset')) {
      const [width,length] = button.dataset.preset.split('x');
      Object.assign(this.state,{custom:true,width,length,height:'150',choices:{},optionColors:{},quantities:{},color:''}); this.render();
    } else if (button.hasAttribute('data-custom')) {
      if (this.model()?.fixedSizes) return;
      Object.assign(this.state,{custom:true,choices:{},optionColors:{},quantities:{},color:''}); this.notice('size_reset'); this.render(); this.q('[data-field="width"]')?.focus();
    } else if (button.hasAttribute('data-orientation')) { this.state.orientation = button.dataset.orientation; this.renderSizes(); this.renderSummary(); this.persist(); }
    else if (button.hasAttribute('data-color')) { this.state.color = button.dataset.color; this.renderEquipment(); this.renderSummary(); this.persist(); }
    else if (button.hasAttribute('data-goto')) this.go(Number(button.dataset.goto));
    else if (button.hasAttribute('data-back')) this.go(this.state.step - 1);
    else if (button.hasAttribute('data-next') || button.hasAttribute('data-mobile-next')) {
      if (this.state.step < 4) this.go(this.state.step + 1);
      else if (this.purchaseStatus().ready) this.addPoolToCart(); else this.go(3);
    } else if (button.hasAttribute('data-reset')) { this.state = this.initial(); this.filter = 'all'; this.render(); this.q('.pool-progress').scrollIntoView({block:'start'}); }
    else if (button.hasAttribute('data-send') && this.config.testMode) this.testSend();
    else if (button.hasAttribute('data-save')) this.download();
  }

  onInput(event) {
    const field = event.target.dataset.field;
    if (!['width','length','height','notes'].includes(field)) return;
    this.state[field] = event.target.value;
    if (['width','length','height'].includes(field) && this.size() && this.number(event.target.value) !== this.size()[field]) this.state.custom = true;
    if (field === 'width' && this.model()?.shape === 'round') this.state.length = this.state.width;
    event.target.removeAttribute('aria-invalid');
    this.persist(); this.renderSummary();
  }

  onChange(event) {
    const input = event.target;
    if (input.hasAttribute('data-package')) { this.setPackage(input.dataset.package, input.value); return; }
    if (input.hasAttribute('data-filter')) { this.filter = input.value; this.renderModels(); return; }
    if (input.hasAttribute('data-group')) { this.setOption(input.dataset.group, input.value); return; }
    if (input.hasAttribute('data-color-group')) {
      const group = input.dataset.colorGroup;
      const option = this.data.miamiOptions[this.state.choices[group]];
      if (option?.colors.some(c => c.id === input.value)) this.state.optionColors[group] = input.value;
      this.renderSummary(); this.persist(); return;
    }
    if (input.hasAttribute('data-quantity-group')) {
      const group = input.dataset.quantityGroup;
      this.state.quantities[group] = Number(input.value);
      this.renderSummary(); this.persist(); return;
    }
    const field = input.dataset.field;
    if (field && Object.hasOwn(this.state,field) && !['choices','step','type','model','size'].includes(field)) {
      this.state[field] = input.value;
      if (field === 'placement') { this.normalizePlacement(); input.value = this.state.placement; }
      if (['finish','width','length','height','stairPackage','linerPackage'].includes(field)) this.renderEquipment();
      this.renderSummary(); this.persist();
    }
  }

  notice(key) { const el = this.q('[data-notice]'); el.textContent = this.t(key); el.hidden = false; }
  error(key) { const el = this.q('[data-error]'); el.textContent = this.t(key); el.hidden = false; el.scrollIntoView({block:'center'}); }
  validConfiguration(showError = false) {
    const model = this.model();
    if (!model) { if (showError) this.error('error_model'); return false; }
    const constraint = this.modelConstraint();
    if (constraint) { if (showError) this.error(constraint); return false; }
    if (model.dimensionsPending && !this.state.custom) return true;
    const valid = ['width','length','height'].every(key => this.number(this.state[key]) !== null);
    if (!valid && showError) {
      this.querySelectorAll('[data-field="width"],[data-field="length"],[data-field="height"]').forEach(field => field.setAttribute('aria-invalid', String(this.number(field.value) === null)));
      this.error('error_dimensions');
    }
    return valid;
  }

  go(step) {
    if (step < 1 || step > 4) return;
    if (step > 1 && !this.model()) { if (this.state.type) { this.q('[data-error]').hidden = true; this.notice('pk_choose_model'); this.focusModels(); } else this.error('error_model'); return; }
    if (step > 2 && !this.validConfiguration(true)) return;
    if (step === 4 && this.state.step !== 4) {
      const journeyData={journey:'pool',model_id:this.state.model,pool_type:this.state.type,purchase_ready:this.purchaseStatus().ready,test_mode:this.config.testMode};
      window.PoolhandelJourney?.track('configuration_completed', journeyData);
      window.PoolhandelJourney?.track('quote_opened', journeyData);
    }
    this.state.step = step;
    this.q('[data-error]').hidden = true;
    this.q('[data-sent]').hidden = true;
    this.renderEquipment(); this.renderSummary(); this.updateStep(); this.renderStarters(); this.persist();
    const title = this.q('[data-step="'+step+'"] h2');
    title.focus({preventScroll:true});
    this.q('.pool-progress').scrollIntoView({behavior:'auto',block:'start'});
  }

  render() {
    this.renderPlacement(); this.renderTypes(); this.renderModels(); this.renderSizes(); this.renderEquipment(); this.renderSummary(); this.updateStep();
    for (const key of ['service','placement','when','notes']) { const field = this.q('[data-field="'+key+'"]'); if (field) field.value = this.state[key]; }
    this.persist();
  }

  renderTypes() {
    const representative = {thermo:'poolhandels-kompletta-poolpaket-bas', tra:'trapool-projekt', glasfiber:'glasfiberpool-minerva', stal:'miami-rectangular'};
    this.q('[data-types]').innerHTML = ['thermo','tra','stal','glasfiber'].map(type => {
      const selected = this.state.type === type;
      return '<button type="button" class="pool-card" data-type="'+type+'" aria-pressed="'+selected+'"><img class="pool-card-image" loading="lazy" width="500" height="280" src="'+this.image(this.models.get(representative[type]).images[0],500)+'" alt=""><span class="pool-card-copy"><span class="pool-card-title">'+this.esc(this.t(type))+'</span><span class="pool-card-desc">'+this.esc(this.t(type+'_intro'))+'</span>'+(['thermo','tra'].includes(type) && this.autumnCampaignActive() ? '<span class="pool-campaign-tag">'+this.esc(this.t('autumn_badge'))+'</span>' : '')+(type==='stal' && this.miamiCampaignActive() ? '<span class="pool-campaign-tag">'+this.esc(this.t('miami_campaign_badge'))+'</span>' : '')+'</span>'+(selected ? '<span class="pool-badge">'+this.esc(this.t('selected'))+'</span>' : '')+'</button>';
    }).join('');
  }

  renderModels() {
    this.q('[data-model-area]').hidden = !this.state.type;
    this.q('[data-length-filter]').hidden = this.state.type !== 'glasfiber';
    const models = this.data.models.filter(m => m.type === this.state.type && (this.state.type !== 'glasfiber' || this.filter === 'all' || (this.filter === 'small' && m.sizes[0].length && m.sizes[0].length <= 500) || (this.filter === 'medium' && m.sizes[0].length > 500 && m.sizes[0].length <= 700) || (this.filter === 'large' && m.sizes[0].length > 700)));
    this.q('[data-models]').innerHTML = models.map(model => {
      const selected = this.state.model === model.id;
      const size = model.sizes[0];
      const meta = model.type === 'glasfiber' && size.length ? size.width+' × '+size.length+' cm · '+size.height+' cm '+this.t('height').replace(' (cm)','').toLowerCase() : model.formLabel || model.vendor;
      return '<button type="button" class="pool-card" data-model="'+this.esc(model.id)+'" aria-pressed="'+selected+'"><img class="pool-card-image" loading="lazy" width="500" height="300" src="'+this.image(model.images[0],500)+'" alt=""><span class="pool-card-copy"><span class="pool-card-title">'+this.esc(model.name)+'</span><span class="pool-card-meta">'+this.esc(meta)+'</span><span class="pool-card-desc">'+this.esc(model.type === 'thermo' ? this.t('pk_model_intro') : model.summary)+'</span><span class="pool-card-price">'+(Number.isFinite(model.price) ? this.esc(this.t('from')+' '+this.money(model.price)) : this.esc(this.t('quote_price')))+'<small>'+this.esc(this.t(model.kind === 'package' ? 'base_package' : model.kind === 'shell' ? 'base_shell' : 'tra'))+'</small></span></span>'+(selected ? '<span class="pool-badge">'+this.esc(this.t('selected'))+'</span>' : '')+'</button>';
    }).join('');
    this.q('[data-no-models]').hidden = !this.state.type || models.length > 0;
  }

  measurementFields() {
    const round = this.model()?.shape === 'round';
    const keys = round ? ['width','height'] : ['width','length','height'];
    return '<div class="pool-dimensions'+(round ? ' two' : '')+'">'+keys.map(key => '<label><span>'+this.esc(this.t(round && key === 'width' ? 'diameter' : key))+'</span><input type="text" inputmode="decimal" autocomplete="off" maxlength="8" data-field="'+key+'" value="'+this.esc(this.state[key])+'"></label>').join('')+'</div>';
  }

  shape() {
    const shape = this.model()?.shape;
    const paths = {rectangular:'M95 32H285V240H95Z', octagon:'M125 32H255L285 62V210L255 240H125L95 210V62Z', round:'M190 36a98 98 0 1 1 0 196a98 98 0 1 1 0-196', oval:'M105 123a85 85 0 0 1 170 0v34a85 85 0 0 1-170 0Z', eight:'M190 35C265 15 295 85 257 135C299 195 258 247 190 234C120 247 79 195 123 135C85 85 115 15 190 35Z', kidney:'M206 30C298 34 290 115 249 154C226 177 263 207 223 232C171 265 82 210 103 150C111 120 96 106 101 78C108 35 148 20 206 30Z', lagoon:'M141 35C201 13 245 24 254 65C278 75 292 110 264 139C289 179 261 219 223 225C190 262 119 245 114 203C75 184 78 141 105 120C77 77 101 36 141 35Z'};
    const mirror = this.size()?.mirror;
    return '<svg class="pool-shape" viewBox="0 0 380 275" role="img" aria-label="'+this.esc(this.t('shape_alt'))+'"><path d="'+(paths[shape] || paths.rectangular)+'" transform="'+(mirror ? 'translate(380 0) scale(-1 1)' : '')+'" fill="#d9eef0" stroke="#087b87" stroke-width="3"/><path d="M305 35V238M298 35H312M298 238H312M95 255H285M95 249V261M285 249V261" fill="none" stroke="#53777f" stroke-width="1.5"/></svg><p class="pool-small pool-shape-caption">'+this.esc(this.t('shape_note'))+'</p>';
  }

  renderSizes() {
    const model = this.model();
    if (!model) { this.q('[data-sizes]').innerHTML = ''; return; }
    let output = '<div class="pool-panel"><h3>'+this.esc(model.name)+'</h3>';
    if (model.type === 'glasfiber') {
      output += '<img class="pool-model-photo" width="900" height="550" src="'+this.image(model.images[0],900)+'" alt="'+this.esc(model.name)+'">';
      if (model.dimensionsPending) output += '<p class="pool-notice">'+this.esc(this.t('avalon_note'))+'</p>';
      else output += '<h4>'+this.esc(this.t('fixed_size'))+'</h4><dl class="pool-fixed-dimensions">'+['width','length','height'].map(key => '<div><dt>'+this.esc(this.t(key))+'</dt><dd>'+this.esc(this.state[key])+' <small>cm</small></dd></div>').join('')+'</dl><p>'+this.esc(this.t('fixed_note'))+'</p>';
      if (model.orientations?.length) output += '<h4>'+this.esc(this.t('orientation'))+'</h4><div class="pool-choices-row">'+model.orientations.map(value => '<button type="button" data-orientation="'+value+'" aria-pressed="'+(this.state.orientation === value)+'">'+this.esc(this.t(value))+'</button>').join('')+'</div><p class="pool-small">'+this.esc(this.t('orientation_note'))+'</p>';
      output += '<p class="pool-small">'+this.esc(this.t('height_note'))+'</p>';
      if (model.documents?.length) output += '<a href="'+this.esc(model.documents[0])+'" target="_blank" rel="noopener">'+this.esc(this.t('drawing'))+'</a>';
    } else {
      output += '<h4>'+this.esc(this.t(model.type === 'tra' ? 'desired_sizes' : 'standard_sizes'))+'</h4><div class="pool-sizes">';
      output += model.sizes.filter(size => !size.mirror).map(size => '<button type="button" class="pool-size" data-size="'+size.id+'" aria-pressed="'+(!this.state.custom && Number(this.state.width) === size.width && Number(this.state.length) === size.length)+'">'+(model.shape === 'round' ? 'Ø '+size.width : size.width+' × '+size.length)+'<small>cm'+(size.quoteOnly ? ' · '+this.esc(this.t('quote_price')) : '')+'</small></button>').join('');
      output += '</div>';
      if (!this.state.custom && model.sizes.some(s => s.mirror)) {
        const twins = model.sizes.filter(s => s.width === this.size().width && s.length === this.size().length);
        output += '<h4>'+this.esc(this.t('orientation'))+'</h4><div class="pool-choices-row">'+twins.sort((a,b) => Number(a.mirror)-Number(b.mirror)).map(size => '<button type="button" data-size="'+size.id+'" aria-pressed="'+(this.state.size === size.id)+'">'+this.esc(this.t(size.mirror ? 'mirrored' : 'normal'))+'</button>').join('')+'</div><p class="pool-small">'+this.esc(this.t('orientation_note'))+'</p>';
      }
      if (!model.fixedSizes) output += '<button type="button" class="pool-secondary" data-custom aria-pressed="'+this.state.custom+'">'+this.esc(this.t('custom_size'))+'</button>';
      if (this.state.custom) output += '<p class="pool-small">'+this.esc(this.t('custom_note'))+'</p>'+this.measurementFields();
      else if (model.type === 'thermo') output += '<div class="pool-dimensions two"><label>'+this.esc(this.t('height'))+'<input type="text" inputmode="decimal" data-field="height" value="'+this.esc(this.state.height)+'" maxlength="8"></label></div><p class="pool-small">'+this.esc(this.t('thermo_height_note'))+'</p>';
      else output += '<p><strong>'+this.esc(this.t('height')+': '+this.state.height)+'</strong></p>';
      output += this.shape()+'<p class="pool-small">'+this.esc(this.t('height_note'))+'</p>';
      if (model.type === 'tra') output += '<p class="pool-notice">'+this.esc(this.constructionNote())+'</p>';
    }
    if (this.largePool()) output += '<p class="pool-notice">'+this.esc(this.t('order_large_quote'))+'</p>';
    if (model.type === 'thermo') output += '<div data-base-breakdown>'+this.thermoBaseMarkup()+'</div>';
    this.q('[data-sizes]').innerHTML = output+'</div>';
  }

  focusModels() {
    const heading = this.q('[data-model-area] h3');
    if (!heading) return;
    heading.focus({preventScroll:true});
    heading.scrollIntoView({block:'start', behavior:'auto'});
  }

  packageGroups() { return ['detailPackage','circulationPackage','coverPackage','carePackage','automationPackage','heatPackage',...(['thermo','tra'].includes(this.model()?.type) ? ['stairPackage','linerPackage'] : [])]; }

  packageDimensions() {
    if (this.model()?.dimensionsPending && !this.state.custom) return null;
    const values = ['width','length','height'].map(key => this.number(this.state[key]));
    if (values.some(value => value === null)) return null;
    const [width,length] = values.slice(0,2).sort((a,b) => a-b);
    return {width,length,height:values[2], small:width <= 300 && length <= 600, volume:width*length*(this.model()?.bathingDepth || values[2])/1000000};
  }

  componentTotal(keys) {
    const prices = keys.map(key => this.packages.components[key]?.price);
    return prices.every(Number.isFinite) ? prices.reduce((sum,value) => sum+value,0) : null;
  }

  packageOptions(group) {
    if (!this.model() || this.model().type === 'stal') return [];
    if (['stairPackage','linerPackage'].includes(group)) return this.extraPackageOptions(group);
    const d = this.packageDimensions();
    const c = this.packages.components;
    const labels = ['pk_standard','pk_premium','pk_luxury'].map(key => this.t(key));
    const builtIn = this.model().included.some(line => /mirrorskimmer/i.test(line));
    const lamps = d?.small ? 1 : 2;
    const sum = keys => this.componentTotal(keys);
    const names = keys => keys.map(key => c[key].name);
    if (group === 'detailPackage') {
      const wood = this.model().type !== 'thermo';
      const detailKeys = ['plasticDetails',this.model().type === 'thermo' ? 'classicThick' : 'classicThin',wood ? 'wideClassicDetails' : 'luxDetails'];
      return ['standard','premium','luxury'].map((id,index) => {
        const aurex = index === 2 && !wood;
        const keys = [detailKeys[index]];
        if (aurex) keys.push('aurexLightKit');
        else keys.push(...Array(lamps).fill(index ? 'classicLight' : 'plasticLight'),'transformer',...Array(lamps).fill('cable'));
        let price = d ? sum(keys) : null;
        if (aurex && lamps === 1 && price !== null) price -= c.aurexLight.price;
        if (builtIn && price !== null) price -= [369000,1049500,1624000][index];
        const detailName = [this.t('pk_plastic'),'Pahlén Classic',wood ? 'Pahlén Wide + Classic' : 'Pahlén Wide + Aurex'][index];
        const lightName = aurex ? 'Aurex 100DVM-RGB' : index ? 'Pahlén Classic LED vit med nisch' : 'LumiPlus Flexi LED vit';
        const title = labels[index]+' – '+detailName+(d ? ' · '+lamps+' '+this.t(lamps === 1 ? 'pk_lamp' : 'pk_lamps') : '');
        const items = [builtIn ? this.t('pk_existing_skimmer') : c[detailKeys[index]].name];
        if (builtIn) items.push(aurex ? '2 × Aurex-inlopp' : index ? '2 × Classic-inlopp' : '2 × plastinlopp med ingjutningsrör');
        items.push((d ? lamps+' × ' : '')+lightName, aurex ? 'Transformator, RGB-styrning, fjärrkontroll och kabelrör' : c.transformer.name+' + '+(d ? lamps+' × ' : '')+c.cable.name);
        const fitting = aurex && this.model().type !== 'thermo';
        return {id,title,price,items,componentKeys:keys,note:(!d ? this.t('pk_pending_dimensions')+' ' : '')+this.t('pk_electrical')+(fitting ? ' '+this.t('pk_aurex_fitting') : ''),unpriced:fitting ? [this.t('pk_mounting_quote')] : []};
      });
    }
    if (group === 'circulationPackage') {
      const fit = d && d.width <= 500 && d.length <= 1000 && d.volume <= 60;
      const size = d && d.volume > 45 ? 620 : d && d.volume > 30 ? 510 : 400;
      return ['standard','premium','luxury'].map((id,index) => {
        const pump = index === 0 ? (d?.small ? 'ecoSmall' : 'ecoLarge') : index === 1 ? 'pilot' : 'whisper';
        const filter = index === 0 ? (d?.small && d.volume <= 30 ? 'galactic400' : 'galactic500') : 'purgo'+size;
        const bags = index === 0 ? (filter === 'galactic400' ? 2 : 4) : size === 400 ? 2 : size === 510 ? 4 : 6;
        const pipe = d && d.width <= 400 && d.length <= 800 ? 'pipeSmall' : 'pipeLarge';
        const keys = [pump,filter,pipe,...Array(bags/2).fill('afm1'),...Array(bags/2).fill('afm2')];
        const capacity = fit && (index !== 0 || d.volume <= 50);
        return {id,title:labels[index]+' – '+c[pump].name+' + '+c[filter].name,price:capacity ? sum(keys) : null,componentKeys:keys,
          items:[c[pump].name,c[filter].name,(bags/2)+' × '+c.afm1.name,(bags/2)+' × '+c.afm2.name,c[pipe].name+' ('+c[pipe].sku+')',this.t('pk_pipes')],
          note:(capacity ? '' : this.t('pk_capacity_quote')+' ')+this.t('pk_install_note')+' '+this.t('pk_afm_note')};
      });
    }
    if (group === 'coverPackage') {
      const titles = {bar:'Bar-Cover',sveltea:'Lamell Sveltea',beach:'Lamell Beach',nova:'Pooltak Nova',ultra:'Pooltak Astral Ultra'};
      const options = Object.entries(titles).filter(([id]) => id !== 'beach' || this.model().type !== 'glasfiber').map(([id,title]) => {
        const band = d ? this.packages.covers[id].filter(row => row.width >= d.width && row.length >= d.length).sort((a,b) => a.width*a.length-b.width*b.length || a.width-b.width)[0] : null;
        const price = band ? (band.component ? c[band.component]?.price : band.price) : null;
        return {id,title,price:Number.isFinite(price) && price > 0 ? price : null,componentKeys:band?.component ? [band.component] : [],existingSale:id==='bar',regularPrice:id==='bar' && Number.isFinite(price) ? Math.round(price/0.8) : undefined,items:[this.t('pk_'+id+'_contents'),...(band ? [(band.width/100)+' × '+(band.length/100)+' m'] : [])],note:this.t(id === 'beach' ? 'pk_beach_note' : 'pk_cover_fit')};
      });
      options.push({id:'none',title:this.t('order_no_cover'),price:0,items:[],note:this.t('order_no_cover_note')});
      options.push({id:'other',title:this.t('pk_other_cover'),price:null,items:[],note:this.t('pk_unpriced')});
      return options;
    }
    if (group === 'carePackage') {
      const keys = [...this.packages.care,d?.small ? 'hose10' : 'hose15'];
      return ['standard','premium','luxury'].map((id,index) => {
        const kit = [...keys,...(index ? [index === 1 ? 'freedom' : 'zodiac5400'] : [])];
        return {id,title:labels[index]+' – '+(index ? c[index === 1 ? 'freedom' : 'zodiac5400'].name : this.t('pk_standard_care')),price:d ? sum(kit) : null,componentKeys:kit,items:names(kit),note:this.t('pk_care_note')+(index && this.model().type === 'glasfiber' ? ' '+this.t('pk_robot_fit') : '')};
      });
    }
    if (group === 'automationPackage') return [
      {id:'none',title:this.t('pk_none_auto'),price:0,items:[]},
      {id:'mrPure',title:c.mrPure.name,price:c.mrPure.price,componentKeys:['mrPure'],items:[c.mrPure.name],note:['premium','luxury'].includes(this.state.detailPackage) ? this.t('pk_salt_note') : ''},
      {id:'watersens',title:c.watersens.name,price:c.watersens.price,componentKeys:['watersens'],items:[c.watersens.name],note:''},
      {id:'asin',title:c.asin.name,price:c.asin.price,componentKeys:['asin'],items:[c.asin.name]}
    ];
    if (group === 'heatPackage') return ["heat-calidi-pp11","heat-calidi-pp18","heat-procube-9","heat-procube-12","heat-procube-16"].map(id => {
      const option = this.data.miamiOptions[id];
      return {id,title:option.name,price:option.price,regularPrice:option.regularPrice,items:[option.name],note:this.t('pk_heat_note')};
    }).concat([{id:'none',title:this.t('pk_none_heat'),price:0,items:[]}]);
    return [];
  }

  setPackage(group,id) {
    if (!this.packageGroups().includes(group) || this.model()?.type === 'stal') return;
    if (id !== 'help' && !this.packageOptions(group).some(option => option.id === id)) return;
    this.state[group] = id;
    this.renderPackageEquipment(); this.renderSummary(); this.persist();
    this.q('[data-package="'+group+'"]')?.focus({preventScroll:true});
  }

  packageSelect(group) {
    const options = this.packageOptions(group);
    const current = options.find(option => option.id === this.state[group]);
    const title = this.t('pk_'+group);
    const output = '<div class="pool-panel pool-package-choice"><label><strong>'+this.esc(title)+'</strong><select data-package="'+group+'"><option value="help"'+(!current ? ' selected' : '')+'>'+this.esc(this.t('pk_choose'))+'</option>'+options.map(option => '<option value="'+option.id+'"'+(current === option ? ' selected' : '')+'>'+this.esc(option.title+' · '+(Number.isFinite(option.price) ? this.money(option.price) : this.t('option_quote')))+'</option>').join('')+'</select></label>';
    if (!current) return output+'</div>';
    const autumnDiscount=this.autumnOptionDiscount(group,current);
    const autumnPrice=Number.isFinite(current.price) ? current.price-autumnDiscount : null;
    return output+'<p class="pool-package-price">'+(autumnDiscount>0 ? '<s>'+this.esc(this.money(current.price))+'</s>' : '')+this.esc(Number.isFinite(autumnPrice) ? this.money(autumnPrice) : this.t('pk_unpriced'))+'</p>'+(autumnDiscount>0 ? '<p class="pool-autumn-note">'+this.esc(this.t('autumn_title'))+'</p>' : this.autumnReady() && current.price>0 && (current.regularPrice>current.price || current.existingSale || (current.componentKeys||[]).some(k=>this.packages.components[k]?.regularPrice>this.packages.components[k]?.price)) ? '<p class="pool-autumn-note">'+this.esc(this.t('autumn_existing'))+'</p>' : '')+(current.items?.length ? '<details><summary>'+this.esc(this.t('pk_included'))+'</summary><ul>'+current.items.map(item => '<li>'+this.esc(item)+'</li>').join('')+'</ul></details>' : '')+(current.note ? '<p class="pool-small pool-package-note">'+this.esc(current.note)+'</p>' : '')+'</div>';
  }

  renderPackageEquipment() {
    const model = this.model();
    let output = '';
    const included = model.included;
    if (included.length) output += '<div class="pool-panel"><h3>'+this.esc(this.t('pk_core_title'))+'</h3><ul class="pool-included">'+included.map(line => '<li>'+this.esc(line)+'</li>').join('')+'</ul>'+(model.type === 'thermo' ? '<p class="pool-small">'+this.esc(this.t('pk_replaces'))+'</p>' : '')+'</div>';
    if (model.type === 'glasfiber') output += '<div class="pool-panel"><h3>'+this.esc(this.t('finish'))+'</h3><label>'+this.esc(this.t('color'))+'<select data-field="finish">'+this.data.gjColors.map((name,index) => '<option value="'+this.esc(name)+'"'+(name === this.state.finish ? ' selected' : '')+'>'+this.esc(name+' · '+(index ? this.money(this.order.finishSurcharge) : this.t('included')))+'</option>').join('')+'</select></label><p class="pool-small">'+this.esc(this.t('finish_note'))+'</p>'+this.gjSwatch()+'</div>';
    if (this.largePool()) output += '<p class="pool-notice">'+this.esc(this.t('order_large_quote'))+'</p>';
    output += '<p class="pool-small">'+this.esc(this.t('pk_sizing'))+'</p>'+this.packageGroups().map(group => this.packageSelect(group)).join('');
    if (['thermo','tra'].includes(model.type)) { const kit=this.order.linerKits[model.type+'-'+this.orderDimensionsKey()]; if (kit) output += '<div class="pool-panel"><h3>'+this.esc(kit.name)+'</h3><p>'+this.esc(kit.contents)+'</p><strong>'+this.money(kit.price)+'</strong><p class="pool-small">'+this.esc(this.t('order_linerkit_included'))+'</p></div>'; }
    for (const extra of this.orderSupplements().filter(row=>row.group==='salt')) output += '<div class="pool-panel"><h3>'+this.esc(extra.title)+'</h3><strong>'+this.esc(Number.isFinite(extra.price) ? this.money(extra.price) : this.t('option_quote'))+'</strong><p>'+this.esc(extra.description)+'</p></div>';
    this.q('[data-equipment]').innerHTML = output+'<p class="pool-small">'+this.esc(this.t('pk_price_note'))+'</p>';
  }

  packageRows() {
    const rows = [];
    const model = this.model();
    if (model.type === 'glasfiber') rows.push([this.t('finish'),this.state.finish+' · '+(this.state.finish === '3D Marble White' ? this.t('included') : this.money(this.order.finishSurcharge))]);
    for (const group of this.packageGroups()) {
      const option = this.packageOptions(group).find(o => o.id === this.state[group]);
      rows.push([this.t('pk_'+group),option ? option.title+' · '+(Number.isFinite(option.price) ? this.money(option.price-this.autumnOptionDiscount(group,option)) : this.t('pk_unpriced')) : this.t('help_choose')]);
    }
    return rows;
  }

  genericSelect(field, title, choices) {
    return '<div class="pool-field-block"><label>'+this.esc(this.t(title))+'<select data-field="'+field+'">'+choices.map(([value,key]) => '<option value="'+value+'"'+(this.state[field] === value ? ' selected' : '')+'>'+this.esc(this.t(key))+'</option>').join('')+'</select></label></div>';
  }

  gjSwatch() {
    const index = this.data.gjColors.indexOf(this.state.finish)-1;
    if (index < 0) return '<img class="pool-gj-standard" src="'+this.esc(this.data.gjStandardImage)+'" width="320" height="223" loading="lazy" alt="3D Marble White">';
    return '<svg class="pool-gj-swatch" viewBox="'+(index%6*275)+' '+(Math.floor(index/6)*320)+' 280 320" width="280" height="320" role="img" aria-label="'+this.esc(this.state.finish)+'"><image href="'+this.esc(this.data.gjColorImage)+'" width="1664" height="640"/></svg>';
  }

  renderEquipment() {
    const model = this.model();
    if (!model) { this.q('[data-equipment]').innerHTML = ''; return; }
    if (model.type !== 'stal') { this.renderPackageEquipment(); return; }
    const wasOpen = this.q('[data-more]')?.open || false;
    let output = '';
    if (model.included.length) output += '<div class="pool-panel"><h3>'+this.esc(this.t('included_title'))+'</h3><ul class="pool-included">'+model.included.map(line => '<li>'+this.esc(line)+'</li>').join('')+'</ul><p class="pool-small">'+this.esc(this.t('included_note'))+'</p></div>';
    if (model.type === 'glasfiber') {
      output += '<div class="pool-panel"><h3>'+this.esc(this.t('finish'))+'</h3><label>'+this.esc(this.t('color'))+'<select data-field="finish">'+this.data.gjColors.map((name,index) => '<option value="'+this.esc(name)+'"'+(name === this.state.finish ? ' selected' : '')+'>'+this.esc(name+' · '+(index ? this.money(this.order.finishSurcharge) : this.t('included')))+'</option>').join('')+'</select></label><p class="pool-small">'+this.esc(this.t('finish_note'))+'</p>'+this.gjSwatch()+'<details><summary>'+this.esc(this.t('color_chart'))+'</summary><a href="'+this.esc(this.data.gjColorImage)+'" target="_blank" rel="noopener"><img class="pool-color-chart" src="'+this.esc(this.data.gjColorImage)+'" width="1664" height="640" loading="lazy" alt="'+this.esc(this.data.gjColors.slice(1).join(', '))+'"></a></details></div>';
    }
    if (model.type === 'stal' && !this.state.custom) {
      output += '<div class="pool-panel"><p class="pool-small">'+this.esc(this.t('miami_note'))+'</p>';
      for (const group of this.optionGroups()) output += this.renderMiamiGroup(group);
      output += '</div>';
    } else if (model.kind !== 'package') {
      output += '<div class="pool-panel">'+this.genericSelect('tech','g_equipment',[['help','help_choose'],['basic','tech_basic'],['variable','tech_variable']])+(model.type === 'stal' ? this.renderMiamiGroup('heat') : this.genericSelect('heat','g_heat',[['help','help_choose'],['yes','heat_yes'],['none','heat_no']]))+'<p class="pool-small">'+this.esc(this.t('extras_note'))+'</p></div>';
    } else output += '<div class="pool-panel"><h3>'+this.esc(this.t('package_options'))+'</h3><p>'+this.esc(this.t('package_options_note'))+'</p></div>';
    if (model.type === 'thermo' || model.type === 'tra' || (model.type === 'stal' && this.state.custom)) {
      const liners = [['help','help_choose'],['solid','liner_solid'],['pattern','liner_pattern'],['3d','liner_3d']];
      const stairs = [['help','help_choose'],['ladder','stair_ladder'],['end','stair_end'],['corner','stair_corner']];
      if (model.kind === 'package') { liners.unshift(['package','liner_package']); stairs.unshift(['package','stair_package']); }
      output += '<div class="pool-panel">'+this.genericSelect('linerWish','liner_wish',liners)+this.genericSelect('stairWish','stair_wish',stairs)+'<p class="pool-small">'+this.esc(this.t('extras_note'))+'</p></div>';
    }
    if (model.type !== 'stal') {
    const coverChoices = [['help','cover_help'],['lamell','cover_lamell'],['roof','cover_roof'],['bar','cover_bar']];
    if (model.kind === 'package') coverChoices.unshift(['package','cover_package']);
    output += '<div class="pool-panel">'+this.genericSelect('cover','cover_label',coverChoices)+'<p class="pool-small">'+this.esc(this.t('cover_note'))+'</p></div>';
    } else if (this.state.custom) output += '<div class="pool-panel">'+this.renderMiamiGroup('cover')+'</div>';
    output += '<details class="pool-panel pool-more" data-more'+(wasOpen ? ' open' : '')+'><summary>'+this.esc(this.t('more_options'))+'</summary>'+(model.type === 'stal' && !this.state.custom ? '' : this.genericSelect('light','light_label',[['none','light_none'],['white','light_white'],['rgb','light_rgb']]))+this.genericSelect('care','care_label',[['help','help_choose'],['manual','care_manual'],['auto','care_auto']])+this.genericSelect('robot','robot_label',[['none','robot_no'],['yes','robot_yes']])+'<p class="pool-small">'+this.esc(this.t('extras_note'))+'</p></details>';
    this.q('[data-equipment]').innerHTML = output;
  }

  regularCalculation() {
    const model = this.model();
    const base = !this.state.custom && !this.largePool() && Number.isFinite(this.size()?.price) ? this.size().price : null;
    let additions = 0;
    const lines = [];
    const unpriced = [];
    if (model?.type === 'stal') for (const group of this.optionGroups()) {
      const key = this.state.choices[group];
      const available=this.availableOptions(group);
      if (!available.includes(key)) { if (available.length && group !== 'winter') unpriced.push(this.t('g_'+group)); continue; }
      const option = this.data.miamiOptions[key];
      const color = this.selectedColor(group, option);
      if (option.colors.length && !color) unpriced.push(this.t('g_'+group)+' – '+this.t('color'));
      const quantity = this.optionQuantity(group, option);
      const price = this.optionPrice(group, option);
      const title = (quantity > 1 ? quantity+' × ' : '')+option.name+(color ? ' – '+color.name : '');
      if (!Number.isFinite(price)) { unpriced.push(title); continue; }
      additions += price;
      if (option.mountingQuote) unpriced.push(this.t('pk_mounting_quote'));
      lines.push({group, title, price, campaignFree:this.miamiStairFree(group,option), regularPrice:this.optionRegularPrice(group,option)});
    }
    if (model && model.type !== 'stal') for (const group of this.packageGroups()) {
      const option = this.packageOptions(group).find(o => o.id === this.state[group]);
      if (!option || option.id === 'help') { unpriced.push(this.t('pk_'+group)); continue; }
      if (!Number.isFinite(option.price)) unpriced.push(option.title);
      else { additions += option.price; lines.push({group, title:option.title, price:option.price}); }
      if (option.unpriced) unpriced.push(...option.unpriced);
    }
    if (this.modelConstraint()) unpriced.push(this.t(this.modelConstraint()));
    if (this.largePool()) unpriced.push(this.t('order_large_quote'));
    for (const row of this.orderSupplements()) { if (Number.isFinite(row.price)) { additions += row.price; lines.push(row); } else unpriced.push(row.description || row.title); }
    if (model && model.type !== 'stal') {
      const kit = this.factoryLinerKit();
      if (kit) { additions += kit.price; lines.push({group:'linerKit',title:kit.name,price:kit.price}); }
      else if (['thermo','tra'].includes(model.type) && !model.linerKitIncluded && this.state.linerPackage !== 'welded') unpriced.push(this.t('order_linerkit_missing'));
    }
    const freight = this.freight();
    if (model) { lines.push({group:'freightPool',title:this.t('order_freight_pool'),price:freight.pool}); if (freight.cover) lines.push({group:'freightCover',title:this.t('order_freight_cover'),price:freight.cover}); }
    additions += freight.total;
    return {base, additions, freight, subtotal:base === null ? null : base+additions, lines, unpriced};
  }

  autumnCampaignActive() {
    const c=this.order.autumnCampaign, now=Date.now();
    return !!c?.enabled && now>=Date.parse(c.startsAt) && (!c.endsAt || now<=Date.parse(c.endsAt));
  }

  autumnReady() {
    return this.autumnCampaignActive() && ['thermo','tra'].includes(this.model()?.type)
      && !this.state.custom && !this.largePool() && !this.modelConstraint() && Number.isFinite(this.size()?.price)
      && this.packageGroups().every(group=>{
        const option=this.packageOptions(group).find(o=>o.id===this.state[group]);
        return option && Number.isFinite(option.price) && !option.unpriced?.length;
      });
  }

  autumnParts(line) {
    const freight=line.group==='base' ? this.freight().pool : line.group==='coverPackage' ? this.freight().cover : 0;
    const material=Math.max(0,(line.price || 0)-freight);
    let protectedPrice=0, protectedRegular=0, protectedItems=[];
    if (line.existingSale || (Number.isFinite(line.regularPrice) && line.regularPrice>material)) {
      protectedPrice=material;protectedRegular=line.regularPrice || material;protectedItems=[line.title];
    } else for(const key of line.componentKeys || []) {
      const c=this.packages.components[key];
      if (c && Number.isFinite(c.regularPrice) && c.regularPrice>c.price) {
        protectedPrice+=c.price;protectedRegular+=c.regularPrice;protectedItems.push(c.name);
      }
    }
    protectedPrice=Math.min(material,protectedPrice);
    return {eligible:Math.max(0,material-protectedPrice),protectedPrice,protectedRegular,protectedItems,freight};
  }

  autumnLineDiscount(line) {
    return Math.round(this.autumnParts(line).eligible*this.order.autumnCampaign.rate);
  }

  autumnOptionDiscount(group,option) {
    if (!this.autumnReady() || !option || !Number.isFinite(option.price)) return 0;
    const freight=group==='coverPackage' && ['sveltea','beach','nova','ultra'].includes(option.id) ? this.order.freight.cover : 0;
    return this.autumnLineDiscount({group,price:option.price+freight,regularPrice:option.regularPrice,componentKeys:option.componentKeys,existingSale:option.existingSale});
  }

  calculation() {
    const result=this.regularCalculation();
    if (!this.autumnReady() || result.unpriced.length) return result;
    const discount=this.regularOrderLines().reduce((sum,line)=>sum+this.autumnLineDiscount(line),0);
    return {...result,subtotal:result.subtotal-discount,additions:result.additions-discount,autumn:true,autumnDiscount:discount,beforeAutumn:result.subtotal,
      lines:[...result.lines,{group:'autumnDiscount',title:this.t('autumn_discount'),price:-discount,campaignDiscount:true}]};
  }

  autumnSummaryMarkup(calc) {
    return calc.autumn ? '<div class="pool-autumn-summary"><span>'+this.esc(this.t('autumn_before'))+': '+this.money(calc.beforeAutumn)+'</span><strong>'+this.esc(this.t('autumn_saving'))+': −'+this.money(calc.autumnDiscount)+'</strong><small>'+this.esc(this.t('autumn_existing'))+'</small></div>' : '';
  }

  autumnOrderLines(raw) {
    const output=[];
    for(const line of raw) {
      if (!Number.isFinite(line.price) || line.price<=0) continue;
      const part=this.autumnParts(line), tag=line.key+'-'+line.price;
      const mixed=part.eligible>0 && part.protectedPrice>0;
      const ordinaryDescription=mixed ? line.description.split(';').map(item=>item.trim()).filter(item=>!part.protectedItems.includes(item)).join('; ') : line.description;
      if(part.eligible>0) output.push({...line,key:'autumn-eligible-'+tag+'-'+part.eligible,price:part.eligible-Math.round(part.eligible*this.order.autumnCampaign.rate),regularPrice:part.eligible,checkoutPrice:part.eligible,autumn:true,autumnDiscounted:true,title:mixed ? this.t('pk_'+line.group)+' – '+this.t('autumn_regular_parts') : line.title,description:ordinaryDescription});
      if(part.protectedPrice>0) output.push({...line,key:'autumn-protected-'+tag+'-'+part.protectedPrice,price:part.protectedPrice,regularPrice:part.protectedRegular,checkoutPrice:part.protectedPrice,autumn:true,autumnProtected:true,title:part.eligible>0 ? part.protectedItems.join(', ') : line.title,description:mixed ? part.protectedItems.join('; ') : line.description});
      if(part.freight>0) output.push({key:'autumn-freight-'+part.freight,price:part.freight,checkoutPrice:part.freight,title:this.t(line.group==='base'?'order_freight_pool':'order_freight_cover'),description:'',group:line.group==='base'?'freightPool':'freightCover',autumn:true});
    }
    return output;
  }

  orderLines() {
    const rows=this.regularOrderLines();
    return this.autumnReady() && !this.regularCalculation().unpriced.length ? this.autumnOrderLines(rows) : rows;
  }

  dimensionsLabel() {
    if (this.model()?.dimensionsPending && !this.state.custom) return this.t('quote_price');
    const w=this.number(this.state.width), l=this.number(this.state.length), h=this.number(this.state.height);
    if (!w || !l || !h) return this.t('error_dimensions');
    return (this.model()?.shape === 'round' ? 'Ø '+w : w+' × '+l)+' cm · '+this.t('height').replace(' (cm)','').toLowerCase()+' '+h+' cm'+(this.size()?.mirror && !this.state.custom ? ' · '+this.t('mirrored') : '');
  }

  equipmentRows() {
    const model = this.model();
    if (!model) return [];
    if (model.type !== 'stal') return this.packageRows();
    const rows=[];
    if (model.type === 'glasfiber') rows.push([this.t('finish'), this.state.finish+(this.state.finish !== '3D Marble White' ? ' · '+this.t('option_quote') : ' · '+this.t('included'))]);
    if (model.type === 'stal') {
      for (const group of this.optionGroups()) {
        if (this.state.custom && !['heat','cover'].includes(group)) continue;
        const key = this.state.choices[group];
        const option = this.availableOptions(group).includes(key) ? this.data.miamiOptions[key] : null;
        const color = this.selectedColor(group, option);
        const quantity = this.optionQuantity(group, option);
        const price = this.optionPrice(group, option);
        rows.push([this.t('g_'+group), option ? (quantity > 1 ? quantity+' × ' : '')+option.name+(color ? ' – '+color.name : group === 'liner' ? ' · '+this.t('help_choose') : '')+' · '+(this.miamiStairFree(group,option) ? this.t('miami_campaign_free')+' · '+this.t('miami_campaign_title') : !Number.isFinite(price) ? this.t('not_in_total') : price ? this.money(price) : this.t('no_addition')) : this.t('help_choose')]);
      }
    } else if (model.kind !== 'package') {
      rows.push([this.t('g_equipment'),this.t({help:'help_choose',basic:'tech_basic',variable:'tech_variable'}[this.state.tech] || 'help_choose')]);
      rows.push([this.t('g_heat'),this.t({help:'help_choose',yes:'heat_yes',none:'heat_no'}[this.state.heat] || 'help_choose')]);
    } else rows.push([this.t('base_package'),model.name]);
    if (model.type === 'thermo' || model.type === 'tra' || (model.type === 'stal' && this.state.custom)) {
      rows.push([this.t('liner_wish'),this.t({help:'help_choose',package:'liner_package',solid:'liner_solid',pattern:'liner_pattern','3d':'liner_3d'}[this.state.linerWish] || 'help_choose')]);
      rows.push([this.t('stair_wish'),this.t({help:'help_choose',package:'stair_package',ladder:'stair_ladder',end:'stair_end',corner:'stair_corner'}[this.state.stairWish] || 'help_choose')]);
    }
    if (model.type !== 'stal') rows.push([this.t('cover_label'),this.t({help:'cover_help',package:'cover_package',lamell:'cover_lamell',roof:'cover_roof',bar:'cover_bar'}[this.state.cover] || 'cover_help')]);
    if ((model.type !== 'stal' || this.state.custom) && this.state.light !== 'none') rows.push([this.t('light_label'),this.t(this.state.light === 'rgb' ? 'light_rgb' : 'light_white')+' · '+this.t('option_quote')]);
    if (this.state.care !== 'help') rows.push([this.t('care_label'),this.t(this.state.care === 'auto' ? 'care_auto' : 'care_manual')]);
    if (this.state.robot === 'yes') rows.push([this.t('robot_label'),this.t('robot_yes')+' · '+this.t('option_quote')]);
    return rows;
  }

  projectRows() {
    const rows = [[this.t('installation'),this.t({help:'install_help',self:'install_self',part:'install_part',full:'install_full'}[this.state.service] || 'install_help')],[this.t('placement'),this.placementLabel()],[this.t('when'),this.t({plan:'when_plan',soon:'when_soon',year:'when_year'}[this.state.when] || 'when_plan')]];
    if (this.constructionNote()) rows.push([this.t('order_construction'),this.constructionNote()]);
    if (this.state.notes.trim()) rows.push([this.t('notes'),this.state.notes]);
    return rows;
  }

  rowsMarkup(rows) { return '<dl class="pool-review-list">'+rows.map(([key,value]) => '<dt>'+this.esc(key)+'</dt><dd>'+this.esc(value)+'</dd>').join('')+'</dl>'; }
  reviewPanel(title, rows, step) { return '<div class="pool-panel"><div class="pool-review-heading"><h3>'+this.esc(title)+'</h3><button type="button" data-goto="'+step+'">'+this.esc(this.t('edit'))+'</button></div>'+this.rowsMarkup(rows)+'</div>'; }
  renderSummary() {
    const campaignBanner=this.q('[data-miami-campaign]');
    if (campaignBanner) campaignBanner.hidden=!(this.state.type==='stal' && (!this.model() || this.model().vendor==='Miami Pool') && this.miamiCampaignActive());
    const baseBreakdown=this.q('[data-base-breakdown]');
    if (baseBreakdown && this.model()?.type === 'thermo') baseBreakdown.innerHTML=this.thermoBaseMarkup();
    const model = this.model();
    const calc = this.calculation();
    const autumnBanner=this.q('[data-autumn-campaign]');
    if (autumnBanner) autumnBanner.hidden=!(this.autumnCampaignActive() && ['thermo','tra'].includes(this.state.type));
    const autumnStatus=this.q('[data-autumn-status]');
    if (autumnStatus) autumnStatus.textContent=this.t(calc.autumn ? 'autumn_applied' : 'autumn_pending');
    const price = calc.subtotal === null ? (calc.lines.length ? this.money(calc.additions) : this.t('quote_price')) : this.money(calc.subtotal);
    this.querySelectorAll('[data-price-label]').forEach(el => { el.textContent = this.t(calc.base === null ? 'pk_additions_total' : calc.unpriced.length ? 'order_partial_total' : 'summary_price'); });
    this.querySelectorAll('[data-price-note]').forEach(el => { el.textContent = this.t(calc.base === null && calc.lines.length ? 'pk_base_quote_short' : calc.unpriced.length ? 'order_partial_price' : 'final_quote'); });
    this.querySelectorAll('[data-price]').forEach(el => { el.textContent = price; });
    if (!model) { this.q('[data-aside-content]').innerHTML = '<h3>'+this.esc(this.t('summary_title'))+'</h3><p>'+this.esc(this.t('summary_empty'))+'</p>';this.q('[data-review]').innerHTML='';return; }
    this.q('[data-aside-content]').innerHTML = this.autumnSummaryMarkup(calc)+'<img width="320" height="180" src="'+this.image(model.images[0],500)+'" alt="'+this.esc(model.name)+'"><h3>'+this.esc(model.name)+'</h3><p class="pool-small">'+this.esc(model.vendor)+'</p><dl><dt>'+this.esc(this.t('step_2'))+'</dt><dd>'+this.esc(this.dimensionsLabel())+'</dd><dt>'+this.esc(this.t(model.kind === 'package' ? 'base_package' : 'base_shell'))+'</dt><dd>'+this.esc(calc.base === null ? this.t('quote_price') : this.money(calc.base))+'</dd></dl>'+(calc.lines.some(line => line.price > 0 || line.campaignFree || line.campaignDiscount) ? '<details class="pool-aside-options"><summary>'+this.esc(this.t('priced_options'))+'</summary>'+this.rowsMarkup(calc.lines.filter(line => line.price > 0 || line.campaignFree || line.campaignDiscount).map(line => [line.title,this.calculationLinePrice(line)]))+'</details>' : '')+(calc.unpriced.length ? '<p class="pool-small">'+this.esc(calc.unpriced.join(', ')+' · '+this.t('not_in_total'))+'</p>' : '');
    const dimensionRows = [[this.t('step_2'),this.dimensionsLabel()]];
    if (this.state.custom) dimensionRows.push([this.t('custom_size'),this.t('custom_note')]);
    if (model.orientations?.length) dimensionRows.push([this.t('orientation'),this.t(this.state.orientation)]);
    this.q('[data-review]').innerHTML = this.reviewPanel(this.t('step_1'),[[this.t('step_1'),model.name],[this.t('choose_type'),this.t(model.type)]],1)+this.reviewPanel(this.t('step_2'),dimensionRows,2)+this.reviewPanel(this.t('step_3'),this.equipmentRows(),3)+this.reviewPanel(this.t('project_title'),this.projectRows(),3)+'<div class="pool-panel"><h3>'+this.esc(this.t(calc.base === null ? 'pk_additions_total' : calc.unpriced.length ? 'order_partial_total' : 'summary_price'))+'</h3>'+(calc.base === null ? '<p class="pool-small">'+this.esc(this.t('pk_base_quote'))+'</p>' : '')+this.rowsMarkup([[this.t('base_shell'),calc.base === null ? this.t('quote_price') : this.money(calc.base)],...calc.lines.filter(line=>line.price>0 || line.campaignFree || line.campaignDiscount).map(line=>[line.title,this.calculationLinePrice(line)])]) +this.autumnSummaryMarkup(calc)+'<p class="pool-review-price">'+this.esc(price)+'</p>'+(calc.unpriced.length ? '<p class="pool-small">'+this.esc(calc.unpriced.join(', ')+' · '+this.t('not_in_total'))+'</p>' : '')+'<p class="pool-small">'+this.esc(this.t('price_note'))+'</p></div>';
    this.renderPurchase();
    const body = this.q('[data-contact-body]');if (body) body.value = this.summaryText();
  }

  updateStep() {
    this.querySelectorAll('[data-step]').forEach(section => { section.hidden = Number(section.dataset.step) !== this.state.step; });
    this.querySelectorAll('.pool-progress [data-goto]').forEach(button => {
      const step = Number(button.dataset.goto);
      if (step === this.state.step) button.setAttribute('aria-current','step'); else button.removeAttribute('aria-current');
      button.disabled = step > 1 && !this.model();
    });
    this.q('[data-back]').hidden = this.state.step === 1;
    this.q('[data-next]').hidden = this.state.step === 4;
    const nextText = this.t(this.state.step === 1 && this.state.type && !this.model() ? 'pk_choose_model_button' : this.state.step === 3 ? 'to_summary' : this.state.step === 4 ? 'contact_title' : 'next');
    this.q('[data-next]').textContent = nextText+' →';
    this.q('[data-mobile-next]').textContent = (this.state.step === 4 ? this.t(this.purchaseStatus().ready ? 'order_buy_short' : 'order_finish_choices') : nextText)+' →';
    this.q('[data-mobile-label]').textContent = this.t('step_word')+' '+this.state.step+' '+this.t('of')+' 4 · '+this.t(this.calculation().base === null ? 'pk_additions_total' : 'summary_price');
  }

  summaryText() {
    const model = this.model();if (!model) return '';
    const calc = this.calculation();
    const lines = ['Poolhandel – Poolkonfiguration',model.name,model.vendor,this.dimensionsLabel()];
    if (calc.autumn) lines.push(this.t('autumn_title'),this.t('autumn_before')+': '+this.money(calc.beforeAutumn),this.t('autumn_saving')+': '+this.money(calc.autumnDiscount),this.t('autumn_existing'));
    if (model.handle) lines.push('Produkt: '+model.handle);
    if (this.size()?.nativeVariantId) lines.push('Grundvariant: '+this.size().nativeVariantId);
    if (this.state.custom) lines.push(this.t('custom_note'));
    if (model.dimensionsPending) lines.push(this.t('avalon_note'));
    if (model.orientations?.length) lines.push(this.t('orientation')+': '+this.t(this.state.orientation));
    lines.push('',this.t('step_3'),...this.equipmentRows().map(([key,value]) => key+': '+value),'',this.t('project_title'),...this.projectRows().map(([key,value]) => key+': '+value),'',this.t(calc.base === null ? 'pk_additions_total' : calc.unpriced.length ? 'order_partial_total' : 'summary_price')+': '+(calc.subtotal === null ? this.money(calc.additions) : this.money(calc.subtotal)),...(calc.base === null ? [this.t('pk_base_quote')] : []),...(calc.unpriced.length ? [this.t('not_in_total')+': '+calc.unpriced.join(', ')] : []),...calc.lines.filter(line=>['linerKit','freightPool','freightCover','finish','salt'].includes(line.group)).map(line=>line.title+': '+this.money(line.price)),this.t('price_note'),'Prisunderlag: '+this.data.sourceDate,'Konfigurator: '+this.data.version);
    if (model.type !== 'stal') { lines.push('Paketunderlag: '+this.packages.sourceDate); for (const group of this.packageGroups()) { const option = this.packageOptions(group).find(o => o.id === this.state[group]); if (option?.items?.length) lines.push('',option.title,...option.items.map(item => '– '+item)); if (option?.note) lines.push(option.note); } }
    return lines.join('\n');
  }

  orderDimensionsKey() {
    const d = this.packageDimensions();
    return d ? [d.width,d.length,d.height].join('x') : '';
  }

  largePool() {
    const d = this.packageDimensions();
    return !!d && d.width*d.length >= 600*1200;
  }

  weldedLinerPrice() {
    const d = this.packageDimensions();
    if (!d || this.largePool()) return null;
    return this.order.weldedLiner.base + Math.round((Math.max(0,d.width-400)+Math.max(0,d.length-800))/100*this.order.weldedLiner.perMetre);
  }

  factoryLinerKit() {
    if (this.state.linerPackage === 'welded') return null;
    return this.order.linerKits[this.model()?.type+'-'+this.orderDimensionsKey()] || null;
  }

  orderSupplements() {
    const rows=[], model=this.model(), d=this.packageDimensions();
    if (model?.type === 'glasfiber' && this.state.finish !== '3D Marble White') rows.push({key:'finish-800000',group:'finish',title:this.t('order_finish_surcharge'),price:this.order.finishSurcharge,description:this.state.finish});
    if (model?.type !== 'stal' && this.state.automationPackage === 'mrPure') {
      const priced = d && d.width <= 400 && d.length <= 800;
      rows.push({key:'start-salt-6',group:'salt',title:this.t('order_salt_title'),price:priced ? this.order.salt.bags*this.order.salt.unitPrice : null,description:this.t(priced ? 'order_salt_contents' : 'order_salt_larger_quote')});
    }
    return rows;
  }

  extraPackageOptions(group) {
    const d = this.packageDimensions();
    if (!d || !['thermo','tra'].includes(this.model()?.type)) return [];
    if (group === 'stairPackage') {
      if (this.model().subtype === 'garden') return [{id:'ladder',title:this.t('stair_ladder'),price:799000,items:[this.t('order_ladder_contents')]},{id:'special',title:this.t('order_special_stairs'),price:null,items:[],note:this.t('order_garden_stair_note')}];
      const end = this.order.stairs.end[String(d.width)];
      return [
        {id:'ladder',title:this.t('stair_ladder'),price:799000,items:[this.t('order_ladder_contents')]},
        {id:'corner',title:this.t('stair_corner'),price:2215500,items:[this.t('order_corner_contents')],note:this.t('order_stair_liner')},
        {id:'end',title:this.t('stair_end')+' '+(d.width/100)+' m',price:end || null,items:[this.t('order_end_contents')],note:this.t('order_stair_liner')},
        {id:'special',title:this.t('order_special_stairs'),price:null,items:[],note:this.t('order_special_stairs_note')}
      ];
    }
    if (group === 'linerPackage') {
      const steps = ['end','corner'].includes(this.state.stairPackage);
      return this.order.liners.map(style => {
        const row = style.sizes[this.orderDimensionsKey()];
        const regular = row ? row.price + (steps ? 900000 : 0) : null;
        const active = Date.now() >= Date.parse(this.order.campaign.startsAt) && Date.now() < Date.parse(this.order.campaign.endsAt);
        return {id:style.id,title:style.name,price:regular === null ? null : active ? Math.round(regular*0.8) : regular,regularPrice:regular,
          items:[style.name,steps ? this.t('order_liner_steps') : this.t('order_liner_flat')],note:active ? this.t('order_liner_campaign') : ''};
      }).concat([{id:'welded',title:this.t('order_welded_liner'),price:this.weldedLinerPrice(),items:[this.t('order_welded_contents')],note:this.t('order_welded_rule')},{id:'other',title:this.t('order_liner_other'),price:null,items:[]}]);
    }
    return [];
  }

  freight() {
    if (!this.model()) return {pool:0,cover:0,total:0};
    const pool = this.model().type === 'glasfiber' ? this.order.freight.fiberglass : this.order.freight.pool;
    const cover = this.model().type === 'stal' ? /lamell|pooltak/i.test(this.data.miamiOptions[this.state.choices.cover]?.name || '') : ['sveltea','beach','nova','ultra'].includes(this.state.coverPackage);
    return {pool,cover:cover ? this.order.freight.cover : 0,total:pool+(cover ? this.order.freight.cover : 0)};
  }

  orderBaseKey() {
    const model = this.model();
    if (!model || this.state.custom || this.largePool() || this.modelConstraint()) return '';
    return ['thermo','tra'].includes(model.type) ? model.type+'-'+this.orderDimensionsKey() : model.id+'-'+this.state.size;
  }

  checkoutKey(group, option) {
    if (group === 'base') return this.orderBaseKey();
    if (group === 'linerPackage' && option.id === 'welded') return 'welded-'+option.price;
    if (group === 'linerPackage') return 'liner-'+option.id+'-'+this.orderDimensionsKey()+'-'+(['end','corner'].includes(this.state.stairPackage) ? 'steps' : 'flat');
    const freight = group === 'coverPackage' && ['sveltea','beach','nova','ultra'].includes(option.id) ? this.order.freight.cover : 0;
    return group+'-'+option.id+'-'+(option.price+freight);
  }

  regularOrderLines() {
    const model = this.model();
    if (!model) return [];
    const calc = this.regularCalculation();
    const lines = [{key:this.orderBaseKey(),price:calc.base === null ? null : calc.base+this.freight().pool,title:model.name,description:[this.dimensionsLabel(),this.size()?.frameContents].filter(Boolean).join('; '),group:'base'}];
    if (model.type === 'stal') {
      for (const group of this.optionGroups()) {
        const key = this.state.choices[group];
        if (!this.availableOptions(group).includes(key)) continue;
        const option = this.data.miamiOptions[key];
        const price = this.optionPrice(group,option);
        const campaignFree = this.miamiStairFree(group,option);
        if (!Number.isFinite(price) || (!price && !campaignFree)) continue;
        const color = this.selectedColor(group,option);
        const quantity = this.optionQuantity(group,option);
        const extra = group === 'cover' && /lamell|pooltak/i.test(option.name) ? this.order.freight.cover : 0;
        // Keep the regular-price variant: Shopify applies the conditional free-stair discount.
        const unit = this.optionRegularPrice(group,option)/quantity;
        lines.push({key:'miami-'+key+'-'+(unit+extra),price:price/quantity+extra,regularPrice:unit+extra,campaignFree,quantity,title:option.name,supplierSku:color?.id || option.id,group,description:option.contents || color?.name || ''});
      }
    } else {
      for (const group of this.packageGroups()) {
        const option = this.packageOptions(group).find(o => o.id === this.state[group]);
        if (!option || !Number.isFinite(option.price) || !option.price) continue;
        const extra = group === 'coverPackage' && ['sveltea','beach','nova','ultra'].includes(option.id) ? this.order.freight.cover : 0;
        lines.push({key:this.checkoutKey(group,option),price:option.price+extra,regularPrice:option.regularPrice,title:option.title,description:(option.items||[]).join('; '),componentKeys:option.componentKeys,existingSale:option.existingSale,group});
      }
      const kit = this.factoryLinerKit();
      if (kit) lines.push({key:'liner-kit-'+model.type+'-'+this.orderDimensionsKey(),price:kit.price,title:kit.name,description:kit.contents,group:'linerKit'});
    }
    lines.push(...this.orderSupplements().filter(line => Number.isFinite(line.price)));
    return lines;
  }

  purchaseStatus() {
    const missing = [], calc = this.calculation(), model = this.model();
    if (!model) return {ready:false,missing:[this.t('error_model')]};
    if (calc.base === null) missing.push(this.t('base_shell'));
    if (model.type === 'stal') {
      for (const group of ['equipment','details','lighting','transformer','stairs','liner','cover','heat']) {
        if (!this.availableOptions(group).length) continue;
        const option = this.data.miamiOptions[this.state.choices[group]];
        if (!option || !this.availableOptions(group).includes(this.state.choices[group])) missing.push(this.t('g_'+group));
        else if (option.colors?.length && !this.selectedColor(group,option)) missing.push(this.t('g_'+group)+' – '+this.t('color'));
      }
    } else {
      for (const group of this.packageGroups()) if (!this.packageOptions(group).some(o => o.id === this.state[group])) missing.push(this.t('pk_'+group));
    }
    missing.push(...calc.unpriced);
    if (this.state.service !== 'self') missing.push(this.t('order_installation_quote'));
    const lines = this.orderLines();
    const unresolved = lines.filter(line => !this.order.checkout[line.key]);
    if (!missing.length && unresolved.length) missing.push(this.t('order_checkout_pending'));
    return {ready:!missing.length && calc.subtotal > 0,missing:[...new Set(missing)],lines};
  }

  renderPurchase() {
    const target = this.q('[data-purchase]');
    if (!target || !this.model()) return;
    const status = this.purchaseStatus();
    target.innerHTML = '<h3>'+this.esc(this.t(status.ready ? 'order_ready' : 'order_remaining'))+'</h3>'+(status.ready ? '<p>'+this.esc(this.t('order_materials'))+'</p><button type="button" class="pool-primary" data-buy>'+this.esc(this.t('order_buy'))+' →</button>' : '<p>'+this.esc(this.t('order_missing_intro'))+'</p><ul>'+status.missing.map(name=>'<li>'+this.esc(name)+'</li>').join('')+'</ul><button type="button" class="pool-secondary" data-goto="3">'+this.esc(this.t('order_finish_choices'))+'</button>')+'<p class="pool-small">'+this.esc(this.t('order_delivery_note'))+'</p><p data-cart-message role="status" hidden></p>';
  }

  async addPoolToCart() {
    if (this.addingPool) return;
    const status = this.purchaseStatus();
    if (!status.ready) { this.renderPurchase(); return; }
    this.addingPool = true;
    const button = this.q('[data-buy]'), message = this.q('[data-cart-message]');
    if (button) { button.disabled = true; button.textContent = this.t('order_adding'); }
    const root = window.Shopify?.routes?.root || '/';
    const reference = 'P'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,8);
    const current = this.calculation();
    const pendingKey = this.key+'-pending-cart';
    const cleanup = async ref => {
      const response = await fetch(root+'cart.js',{headers:{'Accept':'application/json'},cache:'no-store'});
      if (!response.ok) throw new Error(this.t('order_cart_check'));
      const cart = await response.json();
      const updates = Object.fromEntries(cart.items.filter(item=>item.properties?._pool_configuration===ref).map(item=>[item.key,0]));
      if (Object.keys(updates).length) {
        const removed = await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});
        if (!removed.ok) throw new Error(this.t('order_cart_check'));
      }
    };
    const items = status.lines.filter(line=>line.price > 0 || line.campaignFree || line.campaignDiscount).map(line=>({id:Number(this.order.checkout[line.key].variant),quantity:line.quantity || 1,properties:{'Pool':this.model().name,'Mått':this.dimensionsLabel(),'Val':line.title,'Innehåll':line.description.slice(0,2000),...(line.group==='base'?{'Frakt':line.autumn ? this.t('autumn_freight_separate') : this.money(this.freight().pool)+' ingår',...(this.model().type === 'glasfiber' ? {'Utförande':this.state.finish} : {}),'Orientering':this.model().orientations?.length ? this.t(this.state.orientation) : this.size()?.mirror ? this.t('mirrored') : this.t('normal'),'Installation':this.t('install_self'),'Placering':this.placementLabel(),...(this.constructionNote() ? {'Stomme och placering':this.constructionNote()} : {}),'Önskemål':this.state.notes,'_Valda paket':this.equipmentRows().map(([k,v])=>k+': '+v).join('; ').slice(0,4000)}:{}),...(!line.autumn&&(line.group==='coverPackage'||line.group==='cover')&&this.freight().cover?{'Frakt':this.money(this.freight().cover)+' ingår'}:{}),...(line.supplierSku ? {_supplier_sku:line.supplierSku} : {}),...(line.campaignFree ? {'Kampanj':this.t('miami_campaign_title')+' – Miamipool stålpool'} : {}),...(line.autumnDiscounted ? {'Kampanj':this.t('autumn_title')} : line.autumnProtected ? {'Kampanj':this.t('autumn_existing')} : {}),_pool_configuration:reference}}));
    let attemptStarted=false;
    try {
      let pending=this.pendingPoolReference; try { pending=pending || sessionStorage.getItem(pendingKey); } catch {}
      if (pending) await cleanup(pending);
      this.pendingPoolReference=reference;
      try { sessionStorage.setItem(pendingKey,reference); } catch {}
      attemptStarted=true;
      const response = await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || this.t('order_cart_error'));
      const cartResponse = await fetch(root+'cart.js',{headers:{'Accept':'application/json'},cache:'no-store'});
      if (!cartResponse.ok) throw new Error(this.t('order_cart_check'));
      const cart = await cartResponse.json();
      const added = cart.items.filter(item=>item.properties?._pool_configuration===reference);
      const valid = items.every(item=>added.some(row=>row.variant_id===item.id&&row.quantity===item.quantity));
      const total = added.reduce((sum,item)=>sum+item.final_line_price,0);
      const freeStairsValid = status.lines.filter(line=>line.campaignFree).every(line=>added.some(row=>String(row.variant_id)===String(this.order.checkout[line.key].variant) && row.final_line_price===0 && row.quantity===(line.quantity || 1)));
      const autumnValid=status.lines.filter(line=>line.autumn).every(line=>added.some(row=>String(row.variant_id)===String(this.order.checkout[line.key].variant) && row.final_line_price<=line.price*(line.quantity || 1) && row.quantity===(line.quantity || 1)));
      if (!autumnValid) throw new Error(this.t('autumn_cart_failed'));
      if (!valid || !freeStairsValid || total > current.subtotal || cart.currency !== 'SEK') {
        throw new Error(this.t('order_cart_changed'));
      }
      this.pendingPoolReference=null;
      try { sessionStorage.removeItem(pendingKey); } catch {}
      window.PoolhandelJourney?.track('cart_add_success', {journey:'pool',model_id:this.state.model,pool_type:this.state.type,test_mode:this.config.testMode});
      location.assign(root+'cart');
    } catch(error) {
      // Clear only this attempted configuration, including partial writes after a network error.
      if (attemptStarted) try { await cleanup(reference); this.pendingPoolReference=null; sessionStorage.removeItem(pendingKey); } catch {}
      if (message) { message.hidden=false; message.textContent=error.message || this.t('order_cart_error'); message.scrollIntoView({block:'center'}); }
      if (button) { button.disabled=false; button.textContent=this.t('order_buy'); }
    } finally { this.addingPool=false; }
  }

  requestedModel(handle, id) {
    const canonical = this.data.modelAliases?.[id] || this.data.modelAliases?.[handle];
    return this.models.get(canonical) || this.data.models.find(m => (handle && m.handle === handle) || (id && m.id === id));
  }

  modelConstraint() {
    const model = this.model(), d = this.packageDimensions();
    if (model?.subtype === 'garden' && (this.state.custom || !d || d.height !== 129 || !model.sizes.some(s=>s.width===d.width && s.length===d.length) || this.state.placement !== 'above')) return 'order_garden_fixed';
    if (model?.id === 'trapool-projekt' && (!d || d.width > 400 || d.length > 800 || !['ground','part'].includes(this.state.placement))) return 'order_wood_limit';
    return '';
  }

  normalizePlacement() {
    if (this.model()?.subtype === 'garden') this.state.placement = 'above';
    else if (this.model()?.id === 'trapool-projekt' && !['ground','part'].includes(this.state.placement)) this.state.placement = 'ground';
  }

  placementLabel(value = this.state.placement) {
    if (this.model()?.id === 'trapool-projekt' && ['ground','part'].includes(value)) return this.t(value === 'part' ? 'order_wood_part' : 'order_wood_ground');
    return this.t({help:'place_help',ground:'place_ground',part:'place_part',above:'place_above'}[value] || 'place_help');
  }

  constructionNote() {
    return this.model()?.subtype === 'garden' ? this.t('order_garden_note') : this.model()?.id === 'trapool-projekt' ? this.t('wood_note') : '';
  }

  renderPlacement() {
    const field = this.q('[data-field="placement"]');
    if (!field) return;
    const values = this.model()?.subtype === 'garden' ? ['above'] : this.model()?.id === 'trapool-projekt' ? ['ground','part'] : ['help','ground','part','above'];
    field.innerHTML = values.map(value=>'<option value="'+value+'">'+this.esc(this.placementLabel(value))+'</option>').join('');
    field.value = this.state.placement;
  }

  thermoBaseMarkup() {
    if (this.model()?.type !== 'thermo' || this.state.custom || !Number.isFinite(this.size()?.price)) return '';
    const kit=this.factoryLinerKit();
    const items=[{name:this.t('order_thermo_frame'),price:this.size().price},...(kit?.breakdown || []),{name:this.t('order_freight_pool'),price:this.freight().pool}];
    const total=items.reduce((sum,item)=>sum+item.price,0);
    return '<div class="pool-panel"><h3>'+this.esc(this.t('order_thermo_base_title'))+'</h3>'+this.rowsMarkup(items.map(item=>[item.name,this.money(item.price)]))+'<p><strong>'+this.esc(this.t('order_thermo_base_total'))+': '+this.money(total)+'</strong></p><p>'+this.esc(this.t('order_thermo_base_choices'))+'</p><p class="pool-small">'+this.esc(this.t('order_thermo_base_exclusions'))+'</p></div>';
  }

  testSend() {
    if (!this.config.testMode || !this.validConfiguration(true)) return;
    const invalid = [...this.querySelectorAll('[data-contact-field]')].find(input => input.value && !input.checkValidity());
    if (invalid) { this.error('error_contact');invalid.focus();return; }
    this.q('[data-sent]').hidden = false;
    this.q('[data-sent]').scrollIntoView({block:'center'});
    this.q('[data-error]').hidden = true;
  }

  download() {
    if (!this.validConfiguration(true)) return;
    const url = URL.createObjectURL(new Blob(['\uFEFF'+this.summaryText()], {type:'text/plain;charset=utf-8'}));
    const link = document.createElement('a');link.href=url;link.download='Poolhandel-min-pool.txt';link.click();
    setTimeout(() => URL.revokeObjectURL(url),1000);
    this.notice('download_done');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-product-comparison"]) return;
  try {
    
if(!customElements.get('ph-product-compare'))customElements.define('ph-product-compare',class extends HTMLElement{
 connectedCallback(){if(this.abort)return;this.abort=new AbortController();this.rows=Array.from(this.querySelectorAll('[data-compare-row]'));this.view=this.querySelector('[data-view]');const options={signal:this.abort.signal};this.addEventListener('change',()=>this.update(),options);this.querySelector('[data-reset]').addEventListener('click',()=>{this.view.value='all';this.rows.forEach(r=>{r.querySelector('input').checked=false;});this.update();},options);this.querySelector('[data-compare-controls]').hidden=false;}
 disconnectedCallback(){this.abort?.abort();this.abort=null;}
 update(){let count=0;for(const r of this.rows){r.hidden=this.view.value==='selected'&&!r.querySelector('input').checked;if(!r.hidden)count++;}this.querySelector('[data-empty]').hidden=count>0;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-rib-configurator"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  if (customElements.get('ph-rib')) return;
  class RibConfigurator extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-rib-data]').textContent);
      this.t = this.data.text;
      this.form = this.querySelector('.rib-quote-form');
      this.form.noValidate = true;
      this.field = key => this.querySelector('[data-field="'+key+'"]');
      this.money = cents => new Intl.NumberFormat(document.documentElement.lang || 'sv-SE', {style:'currency',currency:'SEK',maximumFractionDigits:0}).format(cents/100);
      this.querySelectorAll('[data-size]').forEach(button => button.addEventListener('click', () => {
        const [w,l] = button.dataset.size.split('x');
        this.field('width').value=w; this.field('length').value=l; this.field('measured').checked=false;
        this.update();
      }));
      this.querySelector('[data-custom]').addEventListener('click',()=>{this.field('width').focus();this.field('width').select();});
      this.addEventListener('input', e => {if(e.target.matches('[data-field="width"],[data-field="length"]'))this.field('measured').checked=false;this.update();});
      this.addEventListener('change',()=>this.update());
      this.form.addEventListener('submit',e=>this.submit(e));
      this.querySelector('[data-submit]').addEventListener('click',()=>this.order());
      this.querySelector('[data-go-summary]').addEventListener('click',()=>this.querySelector('[data-order]').scrollIntoView({behavior:'smooth',block:'start'}));
      this.querySelector('[data-edit]').addEventListener('click',()=>{this.querySelector('[data-review]').hidden=true;this.field('width').focus();});
      this.querySelectorAll('[data-crank]').forEach(button=>button.addEventListener('click',()=>this.crank(button.dataset.crank)));
      this.addEventListener('focusin',e=>this.classList.toggle('is-editing',e.target.matches('input,select,textarea')));
      this.addEventListener('focusout',()=>setTimeout(()=>this.classList.toggle('is-editing',this.contains(document.activeElement)&&document.activeElement.matches('input,select,textarea')),0));
      this.data.cranks.forEach(c=>this.text('crank-'+c.key,this.money(this.data.testMode?c.price:c.livePrice||c.price)));
      this.update();
    }
    number(key) {
      const s=this.field(key).value.trim().replace(',','.');
      return /^\d+(\.\d{1,2})?$/.test(s)?Number(s):NaN;
    }
    text(key,value) {this.querySelectorAll('[data-out="'+key+'"]').forEach(el=>el.textContent=value);}
    color() {return this.querySelector('[name="rib-color"]:checked').value;}
    dimensionsValid() {return Number.isFinite(this.w)&&Number.isFinite(this.l)&&this.w>=200&&this.w<=550&&this.l>=200&&this.l<=1050&&this.w<=this.l;}
    resolveBand(w,l) {
      const exact=this.data.bands.find(b=>b.width===w&&b.length===l);
      return exact||this.data.bands.filter(b=>b.width>=w&&b.length>=l).sort((a,b)=>a.width*a.length-b.width*b.length||a.width-b.width)[0]||null;
    }
    resolveVariant(band,color) {
      if(!band)return null;
      const list=this.data.testMode?this.data.testVariants:this.data.liveVariants;
      return list.find(v=>v.band===band.key&&v.color===color&&v.price>0&&(this.data.testMode||v.available))||null;
    }
    update() {
      this.w=this.number('width');this.l=this.number('length');
      this.band=this.dimensionsValid()?this.resolveBand(this.w,this.l):null;
      this.special=this.field('special').checked;
      this.offer=!this.special?this.resolveVariant(this.band,this.color()):null;
      this.querySelector('[data-review]').hidden=true;
      this.querySelector('[data-error]').hidden=true;
      this.querySelectorAll('[data-size]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.size===this.w+'x'+this.l)));
      const dims=this.dimensionsValid()?this.w+' × '+this.l+' cm':this.t.enter_dimensions;
      this.text('pool',dims);this.text('cover',this.dimensionsValid()?(this.w+50)+' × '+(this.l+50)+' cm':this.t.enter_dimensions);
      this.text('color',this.color());
      this.text('price',this.offer?this.money(this.offer.price):this.t.quote_price);
      this.text('base',this.offer?this.money(this.offer.base):'');
      this.text('saving',this.offer?this.money(this.offer.base-this.offer.price):'');
      this.text('band',this.band?this.band.label:this.t.quote_price);
      this.text('delivery',this.data.delivery);
      this.text('band-note',this.band?(this.band.width===this.w&&this.band.length===this.l?this.t.standard_price:this.t.custom_price.replace('{size}',this.band.label)):this.t.quote_note);
      this.querySelector('[data-calculation]').hidden=!this.offer;
      this.querySelector('[data-quote-note]').hidden=!!this.offer;
      this.querySelector('[data-special-note]').hidden=!this.special;
      const quote=!this.data.testMode&&!(this.data.orderingEnabled&&this.offer);
      this.querySelector('[data-contact-fields]').hidden=!quote;
      this.querySelector('[data-submit]').hidden=quote;
      this.querySelector('[data-quote-submit]').hidden=!quote;
      for(const name of ['name','email','phone']){this.field(name).disabled=!quote;this.field(name).required=quote&&name!=='phone';}
      this.field('measured').required=!quote;
      this.querySelector('[data-contact-body]').value=Object.entries(this.properties()).map(([key,value])=>key+': '+value).join('\n');
      this.querySelector('[data-submit]').textContent=this.data.testMode?this.t.preview_order:(quote?this.t.ask:this.t.buy);
      this.querySelector('[data-measure-warning]').hidden=this.dimensionsValid();
      this.field('width').setAttribute('aria-invalid',String(!Number.isFinite(this.w)||this.w<200||this.w>550));
      this.field('length').setAttribute('aria-invalid',String(!Number.isFinite(this.l)||this.l<200||this.l>1050||this.w>this.l));
    }
    properties() {
      return {'Modell':'Bar-cover','Poolens innermått (cm)':this.w+' × '+this.l,'Skyddets färdigmått (cm)':(this.w+50)+' × '+(this.l+50),'Färg':this.color(),'Prisgrupp':this.band?.label||'Offert','Överlapp':'25 cm per sida – kontroll före produktion','Ingår':'Vev, säkerhetslås och fästen','Leveranstid':this.data.delivery,'Frakt':'Fri frakt inom Sverige','Kontroll före produktion':'Vi kontaktar kunden och går igenom mått och infästning','Särskild anpassning':this.special?'Ja – offert och ritning krävs':'Nej','Kundens kommentar':this.field('notes').value.trim().slice(0,1000)};
    }
    validate() {
      if(!this.dimensionsValid()){this.fail(this.t.invalid_dimensions);this.field('width').focus();return false;}
      if(this.field('measured').required&&!this.field('measured').checked){this.fail(this.t.confirm_measurements);this.field('measured').focus();return false;}
      const invalid=[...this.querySelectorAll('input,select,textarea')].find(field=>field.willValidate&&!field.validity.valid);
      if(invalid){this.fail(invalid.validationMessage);invalid.focus();invalid.reportValidity();return false;}
      return true;
    }
    fail(message) {const el=this.querySelector('[data-error]');el.textContent=message;el.hidden=false;}
    submit(event) {
      this.update();
      if(this.data.testMode||(this.data.orderingEnabled&&this.offer)||!this.validate())event.preventDefault();
    }
    async order() {
      if(this.busy)return;
      this.update();
      if(!this.validate())return;
      if(this.data.testMode){this.showReview(this.properties(),this.offer?.price??null,this.offer?.id??null);return;}
      if(this.data.orderingEnabled&&this.offer)await this.add(this.offer.id,this.offer.price,this.properties());
    }
    showReview(properties,price,id) {
      const dl=this.querySelector('[data-review-details]');dl.replaceChildren();
      for(const [key,value]of Object.entries(properties)){if(!value)continue;const dt=document.createElement('dt');dt.textContent=key;const dd=document.createElement('dd');dd.textContent=value;dl.append(dt,dd);}
      this.text('review-price',price===null?this.t.quote_price:this.money(price));
      this.querySelector('[data-review]').dataset.variantId=id||'';
      this.querySelector('[data-review]').hidden=false;
      this.querySelector('[data-review]').scrollIntoView({behavior:'smooth',block:'start'});
    }
    async crank(key) {
      const c=this.data.cranks.find(x=>x.key===key);if(!c)return;
      const price=this.data.testMode?c.price:c.livePrice,id=this.data.testMode?c.variantId:c.liveId;
      if(this.data.testMode){this.showReview({'Produkt':c.title,'Passar':c.compatibility,'Typ':'Separat ersättningsvev'},price,id);return;}
      if(this.data.orderingEnabled&&id&&price>0&&c.liveAvailable){await this.add(id,price,{'Passar':c.compatibility});return;}
      window.location.href=c.url||this.data.contactUrl;
    }
    async add(id,expectedPrice,properties) {
      if(this.busy)return;this.busy=true;
      const buttons=this.querySelectorAll('[data-submit],[data-crank]');buttons.forEach(b=>b.disabled=true);
      try {
        const root=window.Shopify?.routes?.root||'/';
        const variantResponse=await fetch(root+'variants/'+id+'.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
        if(!variantResponse.ok)throw new Error('Variant unavailable');
        const variant=await variantResponse.json();if(!variant.available||variant.price!==expectedPrice)throw new Error('Price or availability changed');
        const response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id,quantity:1,properties}]})});
        if(!response.ok)throw new Error('Cart rejected');
        window.location.href=root+'cart';
      } catch(error){this.fail(this.t.cart_error);}finally{this.busy=false;buttons.forEach(b=>b.disabled=false);}
    }
  }
  customElements.define('ph-rib',RibConfigurator);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-spa-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ph-spa-guide')) {
  customElements.define('ph-spa-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.selectors = Array.from(this.querySelectorAll('[data-compare-select]:not([disabled])'));
      this.cards = Array.from(this.querySelectorAll('[data-compare-model]'));
      this.selectors.forEach(select => select.addEventListener('change', () => this.update(), { signal: this.controller.signal }));
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
    update() {
      const selected = this.selectors.map(select => select.value);
      this.selectors.forEach((select, index) => {
        Array.from(select.options).forEach(option => {
          option.disabled = selected.some((value, other) => other !== index && value === option.value);
        });
      });
      this.cards.forEach(card => {
        const index = selected.indexOf(card.dataset.compareModel);
        card.hidden = index === -1;
        card.style.order = index;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-winter-panels"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ph-winter-panels')) {
  customElements.define('ph-winter-panels', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-winter-data]').textContent);
      this.widthInput = this.querySelector('[data-width-input]');
      this.lengthInput = this.querySelector('[data-length-input]');
      this.form = this.querySelector('[data-winter-form]');
      this.add = this.querySelector('[data-add]');
      this.addLabel = this.add.innerHTML;
      this.error = this.querySelector('[data-error]');
      this.format = new Intl.NumberFormat(this.dataset.locale || 'sv-SE', {style:'currency',currency:this.dataset.currency || 'SEK',minimumFractionDigits:2});
      this.querySelectorAll('[data-money]').forEach(cell=>cell.textContent=this.format.format(Number(cell.dataset.money)/100));
      this.number = new Intl.NumberFormat(this.dataset.locale || 'sv-SE', {maximumFractionDigits:2});
      const params = new URLSearchParams(window.location.search);
      for (const [key, input] of [['width',this.widthInput],['length',this.lengthInput]]) {
        if (params.has(key)) input.value = params.get(key);
      }
      const variantId = params.get('variant');
      if (variantId && !params.has('width') && !params.has('length')) {
        const selected = (this.data[this.dataset.finish] || []).find(v => String(v.id) === variantId);
        if (selected) { this.widthInput.value = parseInt(selected.option1,10)-50; this.lengthInput.value = (parseInt(selected.option2,10)-1)*100; }
      }
      this.querySelector('[data-custom-button]').addEventListener('click',()=>{
        this.widthInput.focus();
        this.widthInput.select();
      });
      [this.widthInput,this.lengthInput].forEach(input => input.addEventListener('input',()=>this.update()));
      this.querySelectorAll('button[data-width]').forEach(button => button.addEventListener('click',()=>{
        this.widthInput.value = button.dataset.width;
        this.lengthInput.value = button.dataset.length;
        this.update();
        if (button.closest('.wp-table')) this.querySelector('.wp-grid').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
      }));
      this.form.addEventListener('submit',event=>{
        if (!this.update()) { event.preventDefault(); this.error.focus(); return; }
        this.add.disabled = true;
        this.add.textContent = this.data.labels.adding;
      });
      window.addEventListener('pageshow',()=>this.update());
      this.update();
    }
    setText(selector,value) { this.querySelector(selector).textContent = value; }
    invalid(message) {
      this.add.disabled = true;
      this.querySelector('[data-variant]').value = '';
      this.error.textContent = message;
      this.error.hidden = false;
      this.setText('[data-total]','—');
      return false;
    }
    update() {
      const width = Number(this.widthInput.value), length = Number(this.lengthInput.value);
      const finish = 'black';
      this.querySelectorAll('.wp-preset').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.width)===width && Number(button.dataset.length)===length)));
      if (!this.widthInput.validity.valid || !this.lengthInput.validity.valid || width<100 || width>450 || length<200 || length>1200) return this.invalid(this.data.labels.invalid);
      const panel = [350,400,450,500].find(size=>size>=width+50);
      const count = Math.ceil(length/100)+1;
      const variant = (this.data[finish] || []).find(v=>parseInt(v.option1,10)===panel && parseInt(v.option2,10)===count);
      if (!variant || !variant.available || !Number.isFinite(variant.price) || variant.price<=0) return this.invalid(this.data.labels.unavailable);
      const pool = this.number.format(width/100)+' × '+this.number.format(length/100)+' m';
      const countLabel = this.data.labels.count.replace('__COUNT__',String(count));
      this.setText('[data-summary-pool]',pool);
      this.setText('[data-summary-finish]',this.data.labels[finish]);
      this.setText('[data-summary-count]',countLabel);
      this.setText('[data-summary-length]',panel+' cm');
      this.setText('[data-total]',this.format.format(variant.price/100));
      this.setText('[data-diagram-width]',panel+' cm');
      this.setText('[data-diagram-count]',countLabel);
      this.querySelector('[data-diagram]').dataset.finish = finish;
      this.querySelector('[data-diagram]').style.setProperty('--count',count);
      this.querySelector('[data-variant]').value = variant.id;
      this.querySelector('[data-prop-pool]').value = pool;
      this.querySelector('[data-prop-count]').value = count;
      this.querySelector('[data-prop-length]').value = panel+' cm';
      this.error.hidden = true;
      this.add.innerHTML = this.addLabel;
      this.add.disabled = false;
      return true;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weld-liner"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('weld-liner'))customElements.define('weld-liner',class extends HTMLElement{
async connectedCallback(){if(this.ready)return;this.ready=true;try{this.pricing=await import(this.dataset.pricingModule);}catch{this.pricing=null;}this.catalog=JSON.parse(this.querySelector('[data-catalog]').textContent);this.prices=JSON.parse(this.querySelector('[data-prices]').textContent);this.limit=24;this.selected=null;this.q=s=>this.querySelector(s);['group','vendor'].forEach(k=>this.q('[data-'+k+']').addEventListener('change',()=>{if(k==='group'){this.selected=null;this.q('[data-contact]').hidden=true;}this.limit=24;this.render();this.summary();}));this.q('[data-search]').addEventListener('input',()=>{this.limit=24;this.render();});['size','stairs'].forEach(k=>this.q('[data-'+k+']').addEventListener('change',()=>this.summary()));this.q('[data-more]').addEventListener('click',()=>{this.limit+=24;this.render();});this.q('[data-next]').addEventListener('click',()=>{if(!this.selected){this.q('[data-error]').textContent=this.dataset.required;return;}this.q('[data-contact]').hidden=false;this.q('[data-contact] h2').focus();this.q('[data-contact]').scrollIntoView({behavior:'smooth',block:'start'});});this.q('form').addEventListener('submit',e=>{if(!this.selected){e.preventDefault();this.q('[data-error]').textContent=this.dataset.required;}this.summary();});this.render();this.summary();this.campaignTimer=setInterval(()=>{if(!this.isConnected){clearInterval(this.campaignTimer);return;}this.summary();},60000);}
render(){const group=this.q('[data-group]').value,vendor=this.q('[data-vendor]').value,search=this.q('[data-search]').value.toLocaleLowerCase('sv');const list=this.catalog.filter(p=>p.group===group&&(!vendor||p.vendor===vendor)&&`${p.series} ${p.name}`.toLocaleLowerCase('sv').includes(search));const grid=this.q('[data-grid]');grid.replaceChildren();this.q('[data-results]').textContent=list.length?`${list.length} ${this.dataset.count}`:this.dataset.empty;for(const p of list.slice(0,this.limit)){const b=document.createElement('button');b.type='button';b.className='wl-card';b.setAttribute('aria-pressed',String(this.selected?.key===p.key));if(p.image){const im=document.createElement('img');im.src=p.image;im.alt=`${p.vendor} ${p.series} ${p.name}`;im.loading='lazy';im.width=320;im.height=246;im.addEventListener('error',()=>{const ph=document.createElement('span');ph.className='wl-placeholder';ph.textContent=this.dataset.pending;im.replaceWith(ph);},{once:true});b.append(im);}else{const ph=document.createElement('span');ph.className='wl-placeholder';ph.textContent=this.dataset.pending;b.append(ph);}const small=document.createElement('small');small.textContent=p.vendor+' · '+p.series;const strong=document.createElement('strong');strong.textContent=p.name;b.append(small,strong);b.addEventListener('click',()=>{this.selected=p;this.q('[data-error]').textContent='';this.render();this.summary();});grid.append(b);}this.q('[data-more]').hidden=list.length<=this.limit;}
summary(){const group=this.q('[data-group]'),size=this.q('[data-size]').value,stairs=this.q('[data-stairs]');const value=this.prices[size]?.[group.value+'_'+stairs.value];const amount=Number(String(value||'').replace(/\s/g,'').replace(',','.'));const active=!!this.pricing?.campaignActive();const shown=active?this.pricing.campaignPrice(amount):amount;const fmt=n=>new Intl.NumberFormat('sv-SE',{style:'currency',currency:'SEK',maximumFractionDigits:2}).format(n);const price=amount>0?fmt(shown):this.dataset.quote;this.q('[data-before-price]').hidden=!(active&&amount>0);this.q('[data-before-price]').textContent=this.dataset.beforeCampaign+': '+fmt(amount);this.q('[data-campaign-note]').hidden=!(active&&amount>0);this.q('[data-campaign-note]').textContent=this.dataset.campaignUntil;this.querySelectorAll('[data-liner-campaign]').forEach(el=>el.hidden=!active);this.q('[data-price]').textContent=price;this.q('[data-price-note]').hidden=!(amount>0);const config=`${group.selectedOptions[0].textContent}\n${size} m · ${stairs.selectedOptions[0].textContent}`;this.q('[data-config]').textContent=config;const slot=this.q('[data-selection]');if(!this.initial)this.initial=slot.textContent;slot.replaceChildren();if(this.selected){const p=this.selected;if(p.image){const im=document.createElement('img');im.src=p.image;im.alt=p.name;im.width=280;im.height=200;im.addEventListener('error',()=>im.remove(),{once:true});slot.append(im);}const name=document.createElement('strong');name.textContent=`${p.vendor} ${p.series} ${p.name}`;slot.append(name);this.q('[data-details]').value=`${name.textContent}\n${config}\n${price}\n${this.q('[data-included]').textContent+(active?'\n'+this.dataset.beforeCampaign+': '+fmt(amount)+'\n'+this.dataset.campaignUntil:'')}`;}else{slot.textContent=this.initial;this.q('[data-details]').value='';}}
});

  } catch(e) { console.error(e); }
})();
})();
